<div class="library_tile_view" *ngIf="classFileList != ''">
  <!-- <div id="drag-button-tools">
  <button class="button is-small" 
  *ngIf="viewControl.showHideEditFileUpload && viewControl.hideExistingFileView" (click)="DraggableEnable = !DraggableEnable">
  <ng-container *ngIf="DraggableEnable"> 
     <a class="has-tooltip-left" data-tooltip="Save your re-arrange lesson">
      <i class="fa fa-check"></i> </a>
    </ng-container>
  <ng-container *ngIf="!DraggableEnable">
     <a class="has-tooltip-left" data-tooltip="Edit drag and drop re-arrange your lesson"> 
      <i class="fa fa-pencil"></i> </a>
    </ng-container>
  </button>
  <ng-container *ngIf="DraggableEnable"> 
  <button class="button  is-small" 
  *ngIf="viewControl.showHideEditFileUpload && viewControl.hideExistingFileView" (click)="DraggableEnable = !DraggableEnable">
   <a class="has-tooltip-left" data-tooltip="Save your re-arrange lesson">
      <i class="fa fa-times"></i> </a>
   </button>
</ng-container>
  </div> -->
  <div class="flex-container" *ngIf="
      viewControl.showHideEditFileUpload && viewControl.hideExistingFileView">
    <div #dropListContainer class="drag-drop-container" cdkDropListGroup>
      <div class="flex-item" *ngFor="let item of classFileList; let $index = index" cdkDropList
        [cdkDropListData]="$index">
 
        <div class="card" cdkDrag [cdkDragData]="$index" (cdkDragEntered)="dragEntered($event)"
          (cdkDragMoved)="dragMoved($event)" (cdkDragDropped)="dragDropped($event)">
          <div [hidden]="!DraggableEnable" class="drag-handle" cdkDragHandle>
            <i class="fa fa-crosshairs" aria-hidden="true"></i>
          </div>


          <!-- <button *ngIf="item.price > 0" class="buylesson button is-link is-small is-fullwidth">Buy</button> -->
          <!-- <ng-container *ngIf="lessonView else policyView"> -->
          <div class="card-image" (click)="viewSecureFile(item.message_id, item, $index)">

            <div class="pull-left col-5" *ngIf="item.message_type === 'file'">
              <div class="lesson_image" *ngIf="item.file_type === 'video' || item.file_type === 'image';
                    else otherFileType">
                <img style="max-height: 150px" class="thumb_img" [src]="item.thumb_Url" />
                <span class="thumbImg_span" style="
                      position: absolute;
                      top: 0;
                      height: 100%;
                      width: 100%;
                      opacity: 0.7;
                    ">&nbsp;</span>
                <a class="thumb_play is-small" *ngIf="
                      item.file_type === 'video' ||
                      item.file_type === 'audio' ||
                      item.file_type === 'image'
                    " (click)="viewSecureFile(item.message_id, item, $index)">
                  <i class="fa" [ngClass]="{
                        'fa-eye': item.file_type == 'image',
                        'fa-play-circle-o': item.file_type != 'image'
                      }" aria-hidden="true"></i>
                </a>
              </div>
              <span class="videoDuration" *ngIf="item.file_type === 'video' || item.file_type === 'audio'">
                <div *ngIf="item.duration != 'null'">{{ item.duration }}</div>
              </span>
              <span class="videoDuration" *ngIf="item.file_type !== 'video' && item.file_type !== 'audio'">
                <div *ngIf="item.duration != 'null'">{{ item.duration }}</div>
              </span>
              <ng-template #otherFileType>

                <img class="tile_imgcenter" src="../../../../assets/images/file_types/{{
                      item.file_ext
                    }}.png" (click)="viewSecureFile(item.message_id, item, $index)" />
                <a class="thumb_play is-small" (click)="viewSecureFile(item.message_id, item, $index)">
                  <i class="fa" [ngClass]="{
                        'fa-eye': item.file_type != 'audio',
                        'fa-play-circle-o': item.file_type === 'audio'
                      }" aria-hidden="true"></i>
                </a>
              </ng-template>
            </div>
            <div class="pull-left col-7 mt-1 px-1" (click)="viewSecureFile(item.message_id, item, $index)">
              <label class="title"> {{ item.message != "" ? ((item.message.length > 20 ) ? (item.message | slice:0:20)
                +'...' : item.message) : "No Title" }}</label>
              <label class="shared">{{ item.shared_by }}</label>
              <!-- <label class="shared">{{item?.read_user_ids.length}} Views</label> -->
            </div>
          </div>
          <!-- </ng-container> -->
          <!-- <ng-template #policyView>
            <div class="card-image" (click)="viewDocument(item.message_id, item, $index)">
              
              <div class="pull-left col-5" *ngIf="item.message_type === 'file'">
                <div class="lesson_image"
                  *ngIf="
                    item.file_type === 'video' || item.file_type === 'image';
                    else elseTemplate
                  "
                >
                  <img
                    style="max-height: 150px"
                    class="thumb_img"
                    [src]="item.thumb_Url"
                    
                  />
                  <span
                    class="thumbImg_span"
                    style="
                      position: absolute;
                      top: 0;
                      height: 100%;
                      width: 100%;
                      opacity: 0.7;
                    "
                    >&nbsp;</span
                  >
                  <a
                    class="thumb_play is-small"
                    *ngIf="
                      item.file_type === 'video' ||
                      item.file_type === 'audio' ||
                      item.file_type === 'image'
                    "
                    (click)="viewDocument(item.message_id, item, $index)"
                  >
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-eye': item.file_type == 'image',
                        'fa-play-circle-o': item.file_type != 'image'
                      }"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
                <span
                  class="videoDuration"
                  *ngIf="item.file_type === 'video' || item.file_type === 'audio'"
                >
                  <div *ngIf="item.duration != 'null'">{{ item.duration }}</div>
                </span>
                <span
                  class="videoDuration"
                  *ngIf="item.file_type !== 'video' && item.file_type !== 'audio'"
                >
                  <div *ngIf="item.duration != 'null'">{{ item.duration }}</div>
                </span>
                <ng-template #elseTemplate>
          
                  <img
                    class="tile_imgcenter"
                    src="../../../../assets/images/file_types/{{
                      item.file_ext
                    }}.png"
                    (click)="viewDocument(item.message_id, item, $index)"
                  />
                  <a
                    class="thumb_play is-small"
                    (click)="viewDocument(item.message_id, item, $index)"
                  >
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-eye': item.file_type != 'audio',
                        'fa-play-circle-o': item.file_type === 'audio'
                      }"
                      aria-hidden="true"
                    ></i>
                  </a>
                </ng-template>
              </div>
              <div class="pull-left col-7 mt-1 px-1" (click)="viewDocument(item.message_id, item, $index)">
                <label class="title" >  {{ item.message != "" ? ((item.message.length > 20 ) ?  (item.message | slice:0:20) +'...' : item.message) : "No Title" }}</label>
                <label class="shared">{{ item.shared_by }}</label>
              </div>
            </div>
        </ng-template> -->


          <div class="card-footer px-1">
            <span class="col-7"><a class="has-tooltip-right" data-tooltip="LLM Trained" *ngIf="item?.is_llm_training"><i
                  class="fa-solid fa-robot"></i></a> &nbsp; <label class="subtitle is-6">
                {{ item.created_at | date: "MMM d, y" }}
              </label></span>
            <div class="col-5" *ngIf="isUserRole === 1; else normalUser">
              <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                <!-- <a  class="has-tooltip-top" data-tooltip="Edit"> <i class="fa fa-pencil pad-5-10" *ngIf="item.is_publish" [ngClass]="{'disabled':item.is_publish}" ></i> </a> -->
                <span class="tools">
                  <a class="has-tooltip-top" data-tooltip="summarize" *ngIf="item.summary"
                    (click)="showSummarize(item.message_id)"><i class="fa  fa-file-lines"></i></a>
                  <a class="has-tooltip-top" data-tooltip="Edit" *ngIf="!item.is_publish"
                    (click)="getQuizeDetails(item.message_id)"> <i class="fa fa-pencil"></i></a>
                  <a class="has-tooltip-top" data-tooltip="Publish" *ngIf="!item.is_publish"
                    (click)="Published(item['message_id'])"> <i class="fa fa-paper-plane"
                      [ngClass]="{'disabled':item.is_publish}"></i></a>
                  <!-- <a  class="has-tooltip-top" data-tooltip="Edit" *ngIf="item.is_publish"> <i class="fa fa-pencil "  [ngClass]="{'disabled':item.is_publish}"  ></i></a> -->
                  <a class="has-tooltip-top" data-tooltip="Publish" *ngIf="item.is_publish"> <i
                      class="fa fa-paper-plane " [ngClass]="{'disabled':item.is_publish}"></i></a>
                </span>
                <div class="dropdown mt-2 is-right" [ngClass]="{
                  'is-active': show && dropdownIndex === $index
                }">

                  <div class="dropdown-trigger" (click)="clickit($event, $index)">
                    <a class="is-small pad-5-10 has-tooltip-top" data-tooltip="More Options">
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="dropdown-menu" id="dropdown-menu6" role="menu" (click)="$event.stopPropagation()">
                    <div class="dropdown-content">
                      <!-- <a
                      class="dropdown-item"
                      (click)="getQuizeDetails(item.message_id)"
                    >
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                      Edit
                    </a> -->
                      <!-- <a class="dropdown-item" *ngIf="item.is_question_found" (click)="
                        loadAssessmentQuiz(item.message_id, 'question')
                      ">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                        Assessment Result
                      </a>
                      <a class="dropdown-item" *ngIf="item.is_survey_found" (click)="
                        loadAssessmentQuiz(item.message_id, 'survey')
                      ">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                        Survey Result
                      </a>
                      <a class="dropdown-item" *ngIf="item.is_polls_found" (click)="
                        loadAssessmentQuiz(item.message_id, 'polls')
                      ">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                        Poll Result
                      </a> -->
                      <a class="dropdown-item" (click)="secureFileDownLoad(item)">
                        <i class="fa fa-download" aria-hidden="true"></i>
                        Download
                      </a>
                      <hr class="dropdown-divider" />
                      <a class="dropdown-item" (click)="deleteSecureFile(item)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                        Delete
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #normalUser>
              <div class="col-5" *ngIf="
                item.is_download ||
                item.is_polls_found ||
                item.is_survey_found ||
                item.is_question_found
              ">
                <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                  <div class="dropdown mt-2 is-right" [ngClass]="{
                    'is-active': show && dropdownIndex === $index
                  }">
                    <div class="dropdown-trigger" (click)="clickit($event, $index)">
                      <a class="is-small pad-5-10">
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div class="dropdown-menu" id="dropdown-menu6" role="menu" (click)="$event.stopPropagation()">
                      <div class="dropdown-content">
                        <a class="dropdown-item" *ngIf="item.is_question_found" (click)="
                          loadAssessmentQuiz(
                            item.message_id,
                            'question'
                          )
                        ">
                          <i class="fa fa-pencil" aria-hidden="true"></i>
                          Assessment Test
                        </a>
                        <a class="dropdown-item" *ngIf="item.is_survey_found" (click)="
                          loadAssessmentQuiz(item.message_id, 'survey')
                        ">
                          <i class="fa fa-pencil" aria-hidden="true"></i>
                          Survey Quiz
                        </a>
                        <a class="dropdown-item" *ngIf="item.is_polls_found" (click)="
                          loadAssessmentQuiz(item.message_id, 'polls')
                        ">
                          <i class="fa fa-pencil" aria-hidden="true"></i>
                          Poll Quiz
                        </a>
                        <a class="dropdown-item" *ngIf="item.is_download" (click)="secureFileDownLoad(item)">
                          <i class="fa fa-download" aria-hidden="true"></i>
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="card-content" style="display: none;">

            <div class="media">
              <div class="media-content">
                <div class="columns">
                  <div class="column">
                    <p class="title is-7 is-capitalized" [title]="item.message">
                      {{ item.message != "" ? item.message : "No Title" }}
                      <br>

                    </p>

                    <div *ngIf="isUserRole === 1; else otherUserRole">
                      <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                        <!-- <a  class="has-tooltip-top" data-tooltip="Edit"> <i class="fa fa-pencil pad-5-10" *ngIf="item.is_publish" [ngClass]="{'disabled':item.is_publish}" ></i> </a> -->
                        <span class="tools">
                          <a class="has-tooltip-top" data-tooltip="Edit" *ngIf="!item.is_publish"
                            (click)="getQuizeDetails(item.message_id)"> <i class="fa fa-pencil"></i></a>
                          <a class="has-tooltip-top" data-tooltip="Publish" *ngIf="!item.is_publish"
                            (click)="Published(item['message_id'])"> <i class="fa fa-paper-plane"
                              [ngClass]="{'disabled':item.is_publish}"></i></a>
                          <!-- <a  class="has-tooltip-top" data-tooltip="Edit" *ngIf="item.is_publish"> <i class="fa fa-pencil "  [ngClass]="{'disabled':item.is_publish}"  ></i></a> -->
                          <a class="has-tooltip-top" data-tooltip="Publish" *ngIf="item.is_publish"> <i
                              class="fa fa-paper-plane " [ngClass]="{'disabled':item.is_publish}"></i></a>
                        </span>
                        <div class="dropdown is-right" [ngClass]="{
                          'is-active': show && dropdownIndex === $index
                        }">

                          <div class="dropdown-trigger" (click)="clickit($event, $index)">
                            <a class="is-small pad-5-10 has-tooltip-top" data-tooltip="More Options">
                              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                            </a>
                          </div>
                          <div class="dropdown-menu" id="dropdown-menu6" role="menu" (click)="$event.stopPropagation()">
                            <div class="dropdown-content">
                              <!-- <a
                              class="dropdown-item"
                              (click)="getQuizeDetails(item.message_id)"
                            >
                              <i class="fa fa-pencil" aria-hidden="true"></i>
                              Edit
                            </a> -->
                              <!-- <a class="dropdown-item" *ngIf="item.is_question_found" (click)="
                                loadAssessmentQuiz(item.message_id, 'question')
                              ">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                                Assessment Result
                              </a>
                              <a class="dropdown-item" *ngIf="item.is_survey_found" (click)="
                                loadAssessmentQuiz(item.message_id, 'survey')
                              ">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                                Survey Result
                              </a>
                              <a class="dropdown-item" *ngIf="item.is_polls_found" (click)="
                                loadAssessmentQuiz(item.message_id, 'polls')
                              ">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                                Poll Result
                              </a> -->
                              <a class="dropdown-item" (click)="secureFileDownLoad(item)">
                                <i class="fa fa-download" aria-hidden="true"></i>
                                Download
                              </a>
                              <hr class="dropdown-divider" />
                              <a class="dropdown-item" (click)="deleteSecureFile(item.message_id)">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                                Delete
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #otherUserRole>
                      <div *ngIf="
                        item.is_download ||
                        item.is_polls_found ||
                        item.is_survey_found ||
                        item.is_question_found
                      ">
                        <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                          <div class="dropdown is-right" [ngClass]="{
                            'is-active': show && dropdownIndex === $index
                          }">
                            <div class="dropdown-trigger" (click)="clickit($event, $index)">
                              <a class="is-small pad-5-10">
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                              </a>
                            </div>
                            <div class="dropdown-menu" id="dropdown-menu6" role="menu"
                              (click)="$event.stopPropagation()">
                              <div class="dropdown-content">
                                <a class="dropdown-item" *ngIf="item.is_question_found" (click)="
                                  loadAssessmentQuiz(
                                    item.message_id,
                                    'question'
                                  )
                                ">
                                  <i class="fa fa-pencil" aria-hidden="true"></i>
                                  Assessment Test
                                </a>
                                <a class="dropdown-item" *ngIf="item.is_survey_found" (click)="
                                  loadAssessmentQuiz(item.message_id, 'survey')
                                ">
                                  <i class="fa fa-pencil" aria-hidden="true"></i>
                                  Survey Quiz
                                </a>
                                <a class="dropdown-item" *ngIf="item.is_polls_found" (click)="
                                  loadAssessmentQuiz(item.message_id, 'polls')
                                ">
                                  <i class="fa fa-pencil" aria-hidden="true"></i>
                                  Poll Quiz
                                </a>
                                <a class="dropdown-item" *ngIf="item.is_download" (click)="secureFileDownLoad(item)">
                                  <i class="fa fa-download" aria-hidden="true"></i>
                                  Download
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <p class="shared">{{ item.shared_by }}</p>
                    <p class="subtitle is-6">
                      {{ item.created_at | date: "MMM d, y" }}
                    </p>
                    <p class="subtitle is-6">
                      {{ item.read_user_ids ? item.read_user_ids?.length : 0 }}
                      Views
                    </p>
                    <p class="title has-text-right is-size-3 btn_buylesson" *ngIf="item.price > 0">
                      $ {{ item.price }}
                      <!-- <button *ngIf="item.price > 0" class="button is-link is-outlined is-small">Buy</button> -->
                    </p>
                    <!-- <span *ngIf="item.price!='0.00'; else elseTemplate">
                    <p class="title has-text-right is-size-3 btn_buylesson">$ {{item.price}}
                      <button *ngIf="item.price > 0" class="button is-link is-outlined is-small">Buy</button>
                    </p>
                  </span>
                  <ng-template #elseTemplate>
                    <p class="title has-text-right is-size-3 btn_buylesson">Free</p>
                  </ng-template> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <button *ngIf="item.price > 0" class="buylesson button is-dark is-small is-fullwidth">Buy</button> -->
        </div>
      </div>
    </div>
  </div>

  <!--Play Media -->
  <div class="elibPlaying-Media" *ngIf="!viewControl.hideExistingFileView">
    <div class="columns">
      <div class="column is-8">
        <div class="card">
          <div class="card-content">
            <div class="media">
              <a class="selectFileRemove button is-small has-tooltip-left" (click)="hideReadFile(mesgIds)"
                *ngIf="activeModalSelectFile[mesgIds]" data-tooltip="Back to Policy">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </a>
              <div class="content" *ngIf="!activeModalSelectFile[mesgIds]">
                <a class="delete is-small" title="Hide Player" (click)="disabledVideoPlay()"
                  *ngIf="!activeModalSelectFile[mesgIds]"></a>

                <div class="cs-mediaplayer" *ngIf="mediaContent">
                  <div class="watermark_title">
                    <p class="bg-text">{{ mediaContent.watermark }}</p>
                  </div>

                  <div *ngIf="
                      mediaContent.file_type === 'video' ||
                        mediaContent.file_type === 'audio';
                      else notAudioVideo
                    ">
                    <div class="cs-media-player">
                      <div *ngIf="
                          mediaContent.file_type === 'video';
                          else elseMediaTemplate
                        ">
                        <vg-player *ngIf="mediaContent.file_type === 'video'" (onPlayerReady)="videoPlayerInit($event)">
                          <vg-overlay-play></vg-overlay-play>
                          <vg-buffering></vg-buffering>

                          <vg-scrub-bar>
                            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>/
                            <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                            <div id="video-controls" *ngIf="isVideoQuizFound && isUserRole!==1" style="display: block">
                              <div id="seek-bar-container">
                                <div id="seek-bar">
                                  <div id="current-time">
                                    <div class="bubles" *ngFor="let percent of markerSeekBar"
                                      [ngStyle]="{ left: percent }"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </vg-scrub-bar>
                          <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
                            <!-- <vg-playback-button vgFor="my-video" [playbackValues]="[ '1.0', '2.0', '4.0' ]"></vg-playback-button> -->
                            <vg-play-pause></vg-play-pause>
                            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                            <vg-scrub-bar style="pointer-events: none"></vg-scrub-bar>
                            <vg-mute></vg-mute>
                            <vg-volume></vg-volume>

                            <vg-fullscreen></vg-fullscreen>
                          </vg-controls>

                          <video #media [vgMedia]="media" id="singleVideo" crossorigin
                            (timeupdate)="getVideoPlayingOnTime($event.target.currentTime)">
                            <source [src]="inputSrc" type="video/mp4" />
                          </video>
                          <div class="interactQuiz" *ngIf="isVideoQuizFound && isUserRole!==1"
                            [ngStyle]="{ display: activeQuiz }">
                            <div class="intearctQuestions">
                              <div class="card">
                                <div class="card-header">
                                  <p class="card-header-title">
                                    Interactive Quiz
                                  </p>
                                </div>
                                <div class="card-content scroll-bar pos-relative" infinite-scroll>
                                  <div class="content">
                                    <div *ngFor="
                                          let data of filterVideoQuiz;
                                          let i = index
                                        ">
                                      <div class="badge badge-info">
                                        Question {{ pager.index + 1 }} of
                                        {{ pager.count }}
                                      </div>
                                      <h3 class="is-size-5 label" style="font-size: 17px !important">
                                        {{ pager.index + 1 }}.
                                        <span class="is-medium" [innerHTML]="data.question"></span><i
                                          class="fa fa-circle has-text-danger-dark" aria-hidden="true" style="
                                              font-size: 7px !important;
                                              line-height: 1;
                                              margin: 4px 0px 0px 6px;
                                              color: #ab0101;
                                            " *ngIf="videoQuizRequired"></i>
                                      </h3>
                                      <div class="options videoQuizz">
                                        <div class="" *ngFor="
                                              let option of data.answer;
                                              let i = index
                                            ">
                                          <div class="option has-text-grey-light">
                                            <div class="field">
                                              <input class="is-checkradio" id="{{ option.answer_id }}-{{
                                                    data.question_id
                                                  }}" type="radio" name="{{
                                                    data.question_id
                                                  }}-answers" [(ngModel)]="option.selected"
                                                value="{{ option.answer_id }}" (change)="
                                                    onSelectVideoQuizRadio(
                                                      data,
                                                      option
                                                    )
                                                  " #videoQuiz />
                                              <label [attr.for]="
                                                    option.answer_id +
                                                    '-' +
                                                    data.question_id
                                                  ">{{ option.answer }}</label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                                <footer class="card-footer">
                                  <nav class="pagination is-small" role="navigation" aria-label="pagination">
                                    <button type="button" class="button is-outlined pagination-previous" [ngClass]="{
                                          hidePreviousBtn: pager.index === 0
                                        }" [disabled]="pager.index == 0" [hidden]="pager.index > 1" (click)="
                                          getQuizPreviewNext(pager.index - 1)
                                        ">
                                      Previous
                                    </button>
                                    <div *ngIf="
                                          !videoQuizRequired;
                                          else elseReqTemplate
                                        ">
                                      <button type="button"
                                        class="button is-outlined pagination-previous has-tooltip-top"
                                        data-tooltip="Skip Quiz & Continue video" (click)="onclickSkipVideoQuiz()">
                                        Skip & Continue
                                      </button>
                                    </div>
                                    <ng-template #elseReqTemplate>
                                      <span class="btnQuizisRequired"><i class="fa fa-circle" aria-hidden="true"></i>
                                        Note: Answer is required</span>
                                    </ng-template>
                                    <div *ngIf="
                                          pager.index + 1 >= pager.count;
                                          else elseTemplate
                                        ">
                                      <div *ngIf="
                                            btnContinueVideo;
                                            else elseSubmitTemplate
                                          ">
                                        <button type="button"
                                          class="button is-link is-small pagination-next answerSubmit"
                                          (click)="onClickContiVideo()">
                                          Continue
                                        </button>
                                      </div>
                                      <ng-template #elseSubmitTemplate>
                                        <button type="button"
                                          class="button is-link is-small pagination-next answerSubmit has-tooltip-top"
                                          data-tooltip="Check Quiz Answer and click on submit"
                                          [disabled]="!videoQuizSubmit" *ngIf="!showBtnSpinner" (click)="
                                              submitInteractiveQuiz(
                                                filterVideoQuiz
                                              )
                                            ">
                                          Submit Quiz & Continue
                                        </button>
                                        <a class="button is-link is-loading is-small answerSubmit"
                                          style="min-width: 100px" *ngIf="showBtnSpinner"></a>
                                      </ng-template>
                                    </div>
                                    <ng-template #elseTemplate>
                                      <button type="button" class="button is-outlined pagination-next" (click)="
                                            getQuizPreviewNext(pager.index + 1)
                                          ">
                                        Next
                                      </button>
                                    </ng-template>
                                  </nav>
                                </footer>
                              </div>
                            </div>
                          </div>
                        </vg-player>
                        <!-- <div class="video-block">
                          <div class="video-container">
                            <video
                              #videoStream
                              controls
                              crossorigin
                              playsinline
                              (timeupdate)="
                                getVideoPlayingOnTime($event.target.currentTime)
                              "
                            >
                              <source [src]="inputSrc" type="video/mp4" />
                            </video>
                            <div
                              class="interactQuiz"
                              *ngIf="isVideoQuizFound && isUserRole!==1"
                              [ngStyle]="{ display: activeQuiz }"
                            >
                              <div class="intearctQuestions">
                                <div class="card">
                                  <header class="card-header">
                                    <p class="card-header-title">
                                      Interactive Quiz
                                    </p>
                                  </header>
                                  <div
                                    class="card-content scroll-bar pos-relative"
                                    infinite-scroll
                                  >
                                    <div class="content">
                                      <div
                                        *ngFor="
                                          let data of filterVideoQuiz;
                                          let i = index
                                        "
                                      >
                                        <div class="badge badge-info">
                                          Question {{ pager.index + 1 }} of
                                          {{ pager.count }}
                                        </div>
                                        <h3
                                          class="is-size-5 label"
                                          style="font-size: 17px !important"
                                        >
                                          {{ pager.index + 1 }}.
                                          <span
                                            class="is-medium"
                                            [innerHTML]="data.question"
                                          ></span
                                          ><i
                                            class="fa fa-circle has-text-danger-dark"
                                            aria-hidden="true"
                                            style="
                                              font-size: 7px !important;
                                              line-height: 1;
                                              margin: 4px 0px 0px 6px;
                                              color: #ab0101;
                                            "
                                            *ngIf="videoQuizRequired"
                                          ></i>
                                        </h3>
                                        <div class="options videoQuizz">
                                          <div
                                            class=""
                                            *ngFor="
                                              let option of data.answer;
                                              let i = index
                                            "
                                          >
                                            <div
                                              class="option has-text-grey-light"
                                            >
                                              <div class="field">
                                                <input
                                                  class="is-checkradio"
                                                  id="{{ option.answer_id }}-{{
                                                    data.question_id
                                                  }}"
                                                  type="radio"
                                                  name="{{
                                                    data.question_id
                                                  }}-answers"
                                                  [(ngModel)]="option.selected"
                                                  value="{{ option.answer_id }}"
                                                  (change)="
                                                    onSelectVideoQuizRadio(
                                                      data,
                                                      option
                                                    )
                                                  "
                                                  #videoQuiz
                                                />
                                                <label
                                                  [attr.for]="
                                                    option.answer_id +
                                                    '-' +
                                                    data.question_id
                                                  "
                                                  >{{ option.answer }}</label
                                                >
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                  <footer class="card-footer">
                                    <nav
                                      class="pagination is-small"
                                      role="navigation"
                                      aria-label="pagination"
                                    >
                                      <button
                                        type="button"
                                        class="button is-outlined pagination-previous"
                                        [ngClass]="{
                                          hidePreviousBtn: pager.index === 0
                                        }"
                                        [disabled]="pager.index == 0"
                                        [hidden]="pager.index > 1"
                                        (click)="
                                          getQuizPreviewNext(pager.index - 1)
                                        "
                                      >
                                        Previous
                                      </button>
                                      <div
                                        *ngIf="
                                          !videoQuizRequired;
                                          else elseReqTemplate
                                        "
                                      >
                                        <button
                                          type="button"
                                          class="button is-outlined pagination-previous has-tooltip-top" data-tooltip="Skip Quiz & Continue video"
                                          (click)="onclickSkipVideoQuiz()"
                                        >
                                          Skip & Continue
                                        </button>
                                      </div>
                                      <ng-template #elseReqTemplate>
                                        <span class="btnQuizisRequired"
                                          ><i
                                            class="fa fa-circle"
                                            aria-hidden="true"
                                          ></i>
                                          Note: Answer is required</span
                                        >
                                      </ng-template>
                                      <div
                                        *ngIf="
                                          pager.index + 1 >= pager.count;
                                          else elseTemplate
                                        "
                                      >
                                        <div
                                          *ngIf="
                                            btnContinueVideo;
                                            else elseSubmitTemplate
                                          "
                                        >
                                          <button
                                            type="button"
                                            class="button is-link is-small pagination-next answerSubmit"
                                            (click)="onClickContiVideo()"
                                          >
                                            Continue
                                          </button>
                                        </div>
                                        <ng-template #elseSubmitTemplate>
                                          <button
                                            type="button"
                                            class="button is-link is-small pagination-next answerSubmit has-tooltip-top" data-tooltip="Check Quiz Answer and click on submit"
                                            [disabled]="!videoQuizSubmit"
                                            *ngIf="!showBtnSpinner"
                                            (click)="
                                              submitInteractiveQuiz(
                                                filterVideoQuiz
                                              )
                                            "
                                          >
                                            Submit Quiz & Continue
                                          </button>
                                          <a
                                            class="button is-link is-loading is-small answerSubmit"
                                            style="min-width: 100px"
                                            *ngIf="showBtnSpinner"
                                          ></a>
                                        </ng-template>
                                      </div>
                                      <ng-template #elseTemplate>
                                        <button
                                          type="button"
                                          class="button is-outlined pagination-next"
                                          (click)="
                                            getQuizPreviewNext(pager.index + 1)
                                          "
                                        >
                                          Next
                                        </button>
                                      </ng-template>
                                    </nav>
                                  </footer>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="video-controls"
                            *ngIf="isVideoQuizFound && isUserRole!==1"
                            style="position: relative; display: block"
                          >
                            <div id="seek-bar-container">
                              <div id="seek-bar">
                                <div id="current-time">
                                  <div
                                    class="bubles"
                                    *ngFor="let percent of markerSeekBar"
                                    [ngStyle]="{ left: percent }"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> -->
                      </div>
                      <ng-template #elseMediaTemplate>
                        <vg-player style="height: 490px" *ngIf="mediaContent.file_type === 'audio'"
                          (onPlayerReady)="videoPlayerInit($event)">
                          <vg-overlay-play></vg-overlay-play>
                          <vg-buffering></vg-buffering>

                          <vg-controls>
                            <vg-play-pause></vg-play-pause>
                            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

                            <vg-scrub-bar>
                              <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                              <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                            </vg-scrub-bar>

                            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

                            <vg-mute></vg-mute>
                            <vg-volume></vg-volume>

                            <vg-fullscreen></vg-fullscreen>
                          </vg-controls>

                          <audio #audio [vgMedia]="audio" id="myAudio" preload="none">
                            <source [src]="inputSrc" [type]="'audio/mpeg'" />
                          </audio>
                        </vg-player>
                      </ng-template>
                    </div>
                  </div>
                  <ng-template #notAudioVideo>
                    <div class="" *ngIf="
                        mediaContent.file_type === 'image';
                        else notImageFile
                      ">
                      <img class="thumb_img" [src]="mediaContent.view_Url" [ngxWatermark]="options" />
                    </div>
                    <ng-template #notImageFile>
                      <!-- <div class="">
                        <div
                          class="mediaDocFile"
                          *ngFor="let ic of uploadFileIcons"
                        >
                          <div
                            class="imgFigure"
                            *ngIf="ic.name === mediaContent.file_ext"
                          >
                            <div class="watermark_title">
                              <p class="bg-text">
                                {{ mediaContent.watermark }}
                              </p>
                            </div>
                            <figure class="is-centered is-mobile is-desktop">
                              <img class="tile_imgcenter" [src]="ic.icons" />
                            </figure>
                            <a
                              class="button is-link is-outlined thumb_play is-small"
                              (click)="
                                secureFileViewed(
                                  mediaContent.message_id,
                                  mediaContent
                                )
                              "
                            >
                              <i
                                class="fa"
                                [ngClass]="{
                                  'fa-eye': mediaContent.file_type != 'audio',
                                  'fa-play-circle-o':
                                    mediaContent.file_type === 'audio'
                                }"
                                aria-hidden="true"
                              ></i>
                              View Docment
                            </a>
                          </div>
                        </div>
                      </div> -->
                      <div style="height: 600px">
                        <span class="is-loading" *ngIf="showFileLoadSpinner"
                          style="position: absolute; top: 35%; left: 43%">
                          <img src="../../../../../../assets/images/loader-dot-small.gif" alt="" />
                        </span>
                        <ngx-doc-viewer googleCheckContentLoaded="true" googleCheckInterval="3000" googleMaxChecks="5"
                          url="{{ selectedReadFile }}" viewer="google" style="width: 100%; height: 600px; z-index: 999">
                        </ngx-doc-viewer>
                        <button class="modal-close is-large" aria-label="close"
                          (click)="hideReadFile(mesgIds)"></button>
                      </div>
                    </ng-template>
                  </ng-template>
                  <div class="columns">
                    <div class="column is-9">
                      <p class="is-size-6 title is-7 is-capitalized" title="{{ mediaContent.message }}"
                        [innerHTML]="mediaContent.message"></p>
                      <p class="shared">
                        {{ mediaContent.shared_by }} -
                        {{ mediaContent.created_at | date: "MMM d, y" }}
                      </p>
                    </div>
                    <div class="column" *ngIf="isUserRole != 1">
                      <div *ngIf="
                          mediaContent.is_download ||
                          mediaContent.is_polls_found ||
                          mediaContent.is_survey_found ||
                          mediaContent.is_question_found
                        ">
                        <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                          <div class="dropdown is-right" [ngClass]="{
                              'is-active': show && dropdownIndex === $index
                            }">
                            <div class="dropdown-trigger" (click)="clickit($event, $index)">
                              <a class="is-small pad-5-10">
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                              </a>
                            </div>
                            <div class="dropdown-menu" id="dropdown-menu6" role="menu"
                              (click)="$event.stopPropagation()">
                              <div class="dropdown-content">
                                <a class="dropdown-item" *ngIf="is_question_found" (click)="
                                    loadAssessmentQuiz(
                                      mediaContent.messageId,
                                      'question'
                                    )
                                  ">
                                  <i class="fa fa-pencil" aria-hidden="true"></i>
                                  Assessment Test
                                </a>
                                <a class="dropdown-item" *ngIf="is_survey_found" (click)="
                                    loadAssessmentQuiz(
                                      mediaContent.messageId,
                                      'survey'
                                    )
                                  ">
                                  <i class="fa fa-pencil" aria-hidden="true"></i>
                                  Survey Quiz
                                </a>
                                <a class="dropdown-item" *ngIf="is_polls_found" (click)="
                                    loadAssessmentQuiz(
                                      mediaContent.messageId,
                                      'polls'
                                    )
                                  ">
                                  <i class="fa fa-pencil" aria-hidden="true"></i>
                                  Poll Quiz
                                </a>
                                <a class="dropdown-item" *ngIf="mediaContent.is_download"
                                  (click)="secureFileDownLoad(mediaContent)">
                                  <i class="fa fa-download" aria-hidden="true"></i>
                                  Download
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <nav class="pagination is-small" role="navigation" aria-label="pagination">
                    <button class="button is-outlined pagination-previous" [disabled]="
                        prevDisabled || this.classFileList.length === 1
                      " (click)="getPreVideo(currentIndex)">
                      Previous
                    </button>
                    <button class="button is-outlined pagination-next mar-5" [disabled]="
                        nextDisabled || this.classFileList.length === 1
                      " (click)="getNextVideo(currentIndex)">
                      Next
                    </button>
                  </nav>
                  <h3 *ngIf="mediaContent.description" class="title is-3 descHeading">
                    Description
                  </h3>
                  <div [innerHTML]="mediaContent.description"></div>
                </div>
              </div>
              <div *ngIf="activeModalSelectFile[mesgIds]" style="width: 100%">
                <span class="is-loading is-3" *ngIf="showFileLoadSpinner"><strong>Loading...</strong></span>
                <ngx-doc-viewer class="ngxDocViewer" queryParams="h1=N1" popout-hide="none" viewer="google"
                  googleCheckContentLoaded="true" googleCheckInterval="3000" googleMaxChecks="5"
                  [url]="selectedReadFile" style="width: 100%; height: 80vh; z-index: 999"></ngx-doc-viewer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="card events-card">
          <nav class="tabs is-info is-outlined is-boxed is-fullwidth is-small">
            <div class="container">
              <ul class="doc-views-tabs" style="font-size: 15px">
                <li class="tab" [ngClass]="{'is-active':seletedTab=='lessons'}" (click)="openTab($event, 'lessons')">
                  <a>Policy</a>
                </li>
                <li class="tab" [ngClass]="{'is-active':seletedTab=='notes'}" *ngIf="isUserRole != 1" (click)="openTab($event, 'notes')">
                  <a>Notes</a>
                </li>
              </ul>
            </div>
          </nav>

          <div class="container" style="width:100%">
            <div id="lessons" class="content-tab" *ngIf="seletedTab=='lessons'">
              <div class="card-table">
                <div class="content">
                  <div class="list-wrapper scroll-bar list-overflow" appInfiniteScroll infinite-scroll
                    [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
                    [scrollWindow]="false" (scrolled)="fetchElibraryVideoList()">
                    <ul class="notification-list">
                      <li class="cursor-pointer pos-relative chat-list"
                        *ngFor="let vdo of classFileList; let $index = index" (click)="startPlayListVdo($index, vdo)"
                        [ngClass]="{
                          selectedActive:
                            vdo === currentVideo ||
                            vdo.message_id === currentVideoId
                        }">
                        <div class="columns is-gapless is-clearfix pos-relative display-flex">
                          <div class="column is-clearfix">
                            <p class="is-size-6 title list-active is-7 is-capitalized" [title]="vdo.message">
                              {{ vdo.message ? vdo.message : "No Title" }}
                            </p>
                            <p class="shared">
                              {{ vdo.shared_by }} -
                              {{ vdo.created_at | date: "MMM d, y" }}
                            </p>
                          </div>
                          <div class="field is-small" *ngIf="currentVideoId">
                            <input class="is-checkradio is-small is-success is-circle" id="checkbox" type="checkbox"
                              [checked]="vdo.message_id === currentVideoId" disabled />
                            <label for="checkbox"></label>
                          </div>
                        </div>
                      </li>
                      <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div id="notes" class="content-tab" *ngIf="isUserRole != 1 && seletedTab=='notes'">
              <div *ngIf="is_notes; else elseIsNotesTemplate">
                <form [formGroup]="userNotesForm">
                  <div class="scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true"
                    [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
                    <div class="cardcontent scroll-bar pos-relative" appInfiniteScroll infinite-scroll
                      [scrollWindow]="true" [infiniteScrollDistance]="modalScrollDistance"
                      [infiniteScrollThrottle]="modalScrollThrottle">
                      <div class="notes-form" style="padding: 10px" *ngFor="let item of userNotes; let i = index">
                        <h3 class="notesFormHeading is-size-6 label mar-0-10">
                          {{ i + 1 }}. <span [innerHTML]="item.question"></span>
                        </h3>
                        <input type="hidden" id="{{ item.question_id }}" name="question_id"
                          formControlName="question_id" value="{{ item.question_id }}" />
                        <input type="hidden" id="{{ item.user_notes_id }}" name="user_notes_id"
                          formControlName="user_notes_id" value="{{ item.user_notes_id }}" />
                        <!-- <angular-editor class="scroll-bar" id="{{item.question_id}}" [config]="editorConfig" cols="10" rows="2" formControlName="user_notes" (change)="changeEventUserNotes(item, userNotesForm.value)"></angular-editor> -->
                        <textarea name="notes" class="textarea" id="user_notes_{{ item.question_id }}" cols="30"
                          rows="5" placeholder="Enter the short answer here..." formControlName="notes" (change)="
                            changeEventUserNotes(item, userNotesForm.value)
                          " [value]="item.notes ? item.notes : ''"></textarea>
                      </div>
                    </div>
                    <footer class="card-footer">
                      <div class="columns is-12" style="width: 100%; padding: 12px 0px">
                        <div class="column is-6 has-text-left">
                          <a class="button mar-0-5 is-link is-small has-tooltip-right" data-tooltip="Download Notes"
                            (click)="userNotesDownload(this.userNotes)">
                            <i class="fa fa-download" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div class="column is-6 has-text-right">
                          <!-- <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0" (click)="clearUserNotes()">Clear</button> -->
                          <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="
                              (userNotesForm.valid && !userNotesForm.dirty) ||
                              userNotesForm.invalid
                            " (click)="
                              updatedUserNotes(userNotesForm.value, msgIds)
                            " *ngIf="!showBtnSpinner && userNotes.length > 0">
                            Update Notes
                          </button>
                          <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="
                              (userNotesForm.valid && !userNotesForm.dirty) ||
                              userNotesForm.invalid
                            " (click)="
                              submitUserNotes(userNotesForm.value, msgIds)
                            " *ngIf="!showBtnSpinner && userNotes.length === 0">
                            Save Notes
                          </button>

                          <a class="button is-link is-loading is-small" style="min-width: 100px"
                            *ngIf="showBtnSpinner"></a>
                        </div>
                      </div>
                    </footer>
                  </div>
                </form>
              </div>
              <ng-template #elseIsNotesTemplate>
                <form [formGroup]="userNotesForm">
                  <div class="scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true"
                    [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
                    <div class="notes-form" style="padding: 10px">
                      <input type="hidden" class="input" name="user_notes_id" formControlName="user_notes_id" />
                      <angular-editor class="scroll-bar" id="notes" [config]="editorIsNotesConfig" cols="10" rows="2"
                        formControlName="notes"></angular-editor>
                    </div>
                    <footer class="card-footer">
                      <div class="columns is-12" style="width: 100%; padding: 12px 0px">
                        <div class="column is-6 has-text-left">
                          <a class="button mar-0-5 is-link is-small has-tooltip-right" data-tooltip="Download Notes"
                            (click)="userNotesDownload(this.userNotes)">
                            <i class="fa fa-download" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div class="column is-6 has-text-right">
                          <!-- <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0" (click)="clearUserNotes()">Clear</button> -->
                          <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="
                              (userNotesForm.valid && !userNotesForm.dirty) ||
                              userNotesForm.invalid
                            " (click)="
                              submitUserNotes(userNotesForm.value, msgIds)
                            " *ngIf="!showBtnSpinner && userNotes.length === 0">
                            Save Notes
                          </button>
                          <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="
                              (userNotesForm.valid && !userNotesForm.dirty) ||
                              userNotesForm.invalid
                            " (click)="
                              updatedUserNotes(userNotesForm.value, msgIds)
                            " *ngIf="!showBtnSpinner && userNotes.length > 0">
                            Update Notes
                          </button>
                          <a class="button is-link is-loading is-small" style="min-width: 100px"
                            *ngIf="showBtnSpinner"></a>
                        </div>
                      </div>
                    </footer>
                  </div>
                </form>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" style="display: none;" [ngClass]="{'is-active':!viewControl.hideExistingFileView}">
    <div class="modal-background"></div>
    <div class="modal-content-body">
      <header class="modal-card-head">
        <p class="modal-card-title">{{groupName | titlecase}}</p>
        <span class="pull-right">
          <button class="delete" aria-label="close"
            (click)="viewControl.hideExistingFileView = !viewControl.hideExistingFileView "></button>
        </span>
      </header>
      <div class="modal-card-body">
        <div class="elibPlaying-Media">
          <div class="columns">
            <div class="column is-8">
              <div class="card">
                <div class="card-content">
                  <div class="media">
                    <a class="selectFileRemove button is-small has-tooltip-left" (click)="hideReadFile(mesgIds)"
                      *ngIf="activeModalSelectFile[mesgIds]" data-tooltip="Back to Policy">
                      <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </a>
                    <div class="content" *ngIf="!activeModalSelectFile[mesgIds]">
                      <!-- <a
                        class="delete is-small"
                        title="Hide Player"
                        (click)="disabledVideoPlay()"
                        *ngIf="!activeModalSelectFile[mesgIds]"
                      ></a> -->

                      <div class="cs-mediaplayer" *ngIf="mediaContent">
                        <div class="watermark_title">
                          <p class="bg-text">{{ mediaContent.watermark }}</p>
                        </div>

                        <div *ngIf="
                            mediaContent.file_type === 'video' ||
                              mediaContent.file_type === 'audio';
                            else elseTemplate
                          ">
                          <div class="cs-media-player">
                            <div *ngIf="
                                mediaContent.file_type === 'video';
                                else elseMediaTemplate
                              ">
                              <vg-player *ngIf="mediaContent.file_type === 'video'"
                                (onPlayerReady)="videoPlayerInit($event)">
                                <vg-overlay-play></vg-overlay-play>
                                <vg-buffering></vg-buffering>

                                <vg-scrub-bar>
                                  <vg-scrub-bar-current-time></vg-scrub-bar-current-time>/
                                  <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                                  <div id="video-controls" *ngIf="isVideoQuizFound && isUserRole!==1"
                                    style="display: block">
                                    <div id="seek-bar-container">
                                      <div id="seek-bar">
                                        <div id="current-time">
                                          <div class="bubles" *ngFor="let percent of markerSeekBar"
                                            [ngStyle]="{ left: percent }"></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </vg-scrub-bar>
                                <vg-controls [vgAutohide]="true" [vgAutohideTime]="2">
                                  <!-- <vg-playback-button vgFor="my-video" [playbackValues]="[ '1.0', '2.0', '4.0' ]"></vg-playback-button> -->
                                  <vg-play-pause></vg-play-pause>
                                  <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                                  <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                                  <vg-scrub-bar style="pointer-events: none"></vg-scrub-bar>
                                  <vg-mute></vg-mute>
                                  <vg-volume></vg-volume>

                                  <vg-fullscreen></vg-fullscreen>
                                </vg-controls>

                                <video #media [vgMedia]="media" id="singleVideo" crossorigin
                                  (timeupdate)="getVideoPlayingOnTime($event.target.currentTime)">
                                  <source [src]="inputSrc" type="video/mp4" />
                                </video>
                                <div class="interactQuiz" *ngIf="isVideoQuizFound && isUserRole!==1"
                                  [ngStyle]="{ display: activeQuiz }">
                                  <div class="intearctQuestions">
                                    <div class="card">
                                      <div class="card-header">
                                        <p class="card-header-title">
                                          Interactive Quiz
                                        </p>
                                      </div>
                                      <div class="card-content scroll-bar pos-relative" infinite-scroll>
                                        <div class="content">
                                          <div *ngFor="
                                                let data of filterVideoQuiz;
                                                let i = index
                                              ">
                                            <div class="badge badge-info">
                                              Question {{ pager.index + 1 }} of
                                              {{ pager.count }}
                                            </div>
                                            <h3 class="is-size-5 label" style="font-size: 17px !important">
                                              {{ pager.index + 1 }}.
                                              <span class="is-medium" [innerHTML]="data.question"></span><i
                                                class="fa fa-circle has-text-danger-dark" aria-hidden="true" style="
                                                    font-size: 7px !important;
                                                    line-height: 1;
                                                    margin: 4px 0px 0px 6px;
                                                    color: #ab0101;
                                                  " *ngIf="videoQuizRequired"></i>
                                            </h3>
                                            <div class="options videoQuizz">
                                              <div class="" *ngFor="
                                                    let option of data.answer;
                                                    let i = index
                                                  ">
                                                <div class="option has-text-grey-light">
                                                  <div class="field">
                                                    <input class="is-checkradio" id="{{ option.answer_id }}-{{
                                                          data.question_id
                                                        }}" type="radio" name="{{
                                                          data.question_id
                                                        }}-answers" [(ngModel)]="option.selected"
                                                      value="{{ option.answer_id }}" (change)="
                                                          onSelectVideoQuizRadio(
                                                            data,
                                                            option
                                                          )
                                                        " #videoQuiz />
                                                    <label [attr.for]="
                                                          option.answer_id +
                                                          '-' +
                                                          data.question_id
                                                        ">{{ option.answer }}</label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                      <footer class="card-footer">
                                        <nav class="pagination is-small" role="navigation" aria-label="pagination">
                                          <button type="button" class="button is-outlined pagination-previous"
                                            [ngClass]="{
                                                hidePreviousBtn: pager.index === 0
                                              }" [disabled]="pager.index == 0" [hidden]="pager.index > 1" (click)="
                                                getQuizPreviewNext(pager.index - 1)
                                              ">
                                            Previous
                                          </button>
                                          <div *ngIf="
                                                !videoQuizRequired;
                                                else elseReqTemplate
                                              ">
                                            <button type="button"
                                              class="button is-outlined pagination-previous has-tooltip-top"
                                              data-tooltip="Skip Quiz & Continue video"
                                              (click)="onclickSkipVideoQuiz()">
                                              Skip & Continue
                                            </button>
                                          </div>
                                          <ng-template #elseReqTemplate>
                                            <span class="btnQuizisRequired"><i class="fa fa-circle"
                                                aria-hidden="true"></i>
                                              Note: Answer is required</span>
                                          </ng-template>
                                          <div *ngIf="
                                                pager.index + 1 >= pager.count;
                                                else elseTemplate
                                              ">
                                            <div *ngIf="
                                                  btnContinueVideo;
                                                  else elseSubmitTemplate
                                                ">
                                              <button type="button"
                                                class="button is-link is-small pagination-next answerSubmit"
                                                (click)="onClickContiVideo()">
                                                Continue
                                              </button>
                                            </div>
                                            <ng-template #elseSubmitTemplate>
                                              <button type="button"
                                                class="button is-link is-small pagination-next answerSubmit has-tooltip-top"
                                                data-tooltip="Check Quiz Answer and click on submit"
                                                [disabled]="!videoQuizSubmit" *ngIf="!showBtnSpinner" (click)="
                                                    submitInteractiveQuiz(
                                                      filterVideoQuiz
                                                    )
                                                  ">
                                                Submit Quiz & Continue
                                              </button>
                                              <a class="button is-link is-loading is-small answerSubmit"
                                                style="min-width: 100px" *ngIf="showBtnSpinner"></a>
                                            </ng-template>
                                          </div>
                                          <ng-template #elseTemplate>
                                            <button type="button" class="button is-outlined pagination-next" (click)="
                                                  getQuizPreviewNext(pager.index + 1)
                                                ">
                                              Next
                                            </button>
                                          </ng-template>
                                        </nav>
                                      </footer>
                                    </div>
                                  </div>
                                </div>
                              </vg-player>
                              <!-- <div class="video-block">
                                <div class="video-container">
                                  <video
                                    #videoStream
                                    controls
                                    crossorigin
                                    playsinline
                                    (timeupdate)="
                                      getVideoPlayingOnTime($event.target.currentTime)
                                    "
                                  >
                                    <source [src]="inputSrc" type="video/mp4" />
                                  </video>
                                  <div
                                    class="interactQuiz"
                                    *ngIf="isVideoQuizFound && isUserRole!==1"
                                    [ngStyle]="{ display: activeQuiz }"
                                  >
                                    <div class="intearctQuestions">
                                      <div class="card">
                                        <header class="card-header">
                                          <p class="card-header-title">
                                            Interactive Quiz
                                          </p>
                                        </header>
                                        <div
                                          class="card-content scroll-bar pos-relative"
                                          infinite-scroll
                                        >
                                          <div class="content">
                                            <div
                                              *ngFor="
                                                let data of filterVideoQuiz;
                                                let i = index
                                              "
                                            >
                                              <div class="badge badge-info">
                                                Question {{ pager.index + 1 }} of
                                                {{ pager.count }}
                                              </div>
                                              <h3
                                                class="is-size-5 label"
                                                style="font-size: 17px !important"
                                              >
                                                {{ pager.index + 1 }}.
                                                <span
                                                  class="is-medium"
                                                  [innerHTML]="data.question"
                                                ></span
                                                ><i
                                                  class="fa fa-circle has-text-danger-dark"
                                                  aria-hidden="true"
                                                  style="
                                                    font-size: 7px !important;
                                                    line-height: 1;
                                                    margin: 4px 0px 0px 6px;
                                                    color: #ab0101;
                                                  "
                                                  *ngIf="videoQuizRequired"
                                                ></i>
                                              </h3>
                                              <div class="options videoQuizz">
                                                <div
                                                  class=""
                                                  *ngFor="
                                                    let option of data.answer;
                                                    let i = index
                                                  "
                                                >
                                                  <div
                                                    class="option has-text-grey-light"
                                                  >
                                                    <div class="field">
                                                      <input
                                                        class="is-checkradio"
                                                        id="{{ option.answer_id }}-{{
                                                          data.question_id
                                                        }}"
                                                        type="radio"
                                                        name="{{
                                                          data.question_id
                                                        }}-answers"
                                                        [(ngModel)]="option.selected"
                                                        value="{{ option.answer_id }}"
                                                        (change)="
                                                          onSelectVideoQuizRadio(
                                                            data,
                                                            option
                                                          )
                                                        "
                                                        #videoQuiz
                                                      />
                                                      <label
                                                        [attr.for]="
                                                          option.answer_id +
                                                          '-' +
                                                          data.question_id
                                                        "
                                                        >{{ option.answer }}</label
                                                      >
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
      
                                        </div>
                                        <footer class="card-footer">
                                          <nav
                                            class="pagination is-small"
                                            role="navigation"
                                            aria-label="pagination"
                                          >
                                            <button
                                              type="button"
                                              class="button is-outlined pagination-previous"
                                              [ngClass]="{
                                                hidePreviousBtn: pager.index === 0
                                              }"
                                              [disabled]="pager.index == 0"
                                              [hidden]="pager.index > 1"
                                              (click)="
                                                getQuizPreviewNext(pager.index - 1)
                                              "
                                            >
                                              Previous
                                            </button>
                                            <div
                                              *ngIf="
                                                !videoQuizRequired;
                                                else elseReqTemplate
                                              "
                                            >
                                              <button
                                                type="button"
                                                class="button is-outlined pagination-previous has-tooltip-top" data-tooltip="Skip Quiz & Continue video"
                                                (click)="onclickSkipVideoQuiz()"
                                              >
                                                Skip & Continue
                                              </button>
                                            </div>
                                            <ng-template #elseReqTemplate>
                                              <span class="btnQuizisRequired"
                                                ><i
                                                  class="fa fa-circle"
                                                  aria-hidden="true"
                                                ></i>
                                                Note: Answer is required</span
                                              >
                                            </ng-template>
                                            <div
                                              *ngIf="
                                                pager.index + 1 >= pager.count;
                                                else elseTemplate
                                              "
                                            >
                                              <div
                                                *ngIf="
                                                  btnContinueVideo;
                                                  else elseSubmitTemplate
                                                "
                                              >
                                                <button
                                                  type="button"
                                                  class="button is-link is-small pagination-next answerSubmit"
                                                  (click)="onClickContiVideo()"
                                                >
                                                  Continue
                                                </button>
                                              </div>
                                              <ng-template #elseSubmitTemplate>
                                                <button
                                                  type="button"
                                                  class="button is-link is-small pagination-next answerSubmit has-tooltip-top" data-tooltip="Check Quiz Answer and click on submit"
                                                  [disabled]="!videoQuizSubmit"
                                                  *ngIf="!showBtnSpinner"
                                                  (click)="
                                                    submitInteractiveQuiz(
                                                      filterVideoQuiz
                                                    )
                                                  "
                                                >
                                                  Submit Quiz & Continue
                                                </button>
                                                <a
                                                  class="button is-link is-loading is-small answerSubmit"
                                                  style="min-width: 100px"
                                                  *ngIf="showBtnSpinner"
                                                ></a>
                                              </ng-template>
                                            </div>
                                            <ng-template #elseTemplate>
                                              <button
                                                type="button"
                                                class="button is-outlined pagination-next"
                                                (click)="
                                                  getQuizPreviewNext(pager.index + 1)
                                                "
                                              >
                                                Next
                                              </button>
                                            </ng-template>
                                          </nav>
                                        </footer>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  id="video-controls"
                                  *ngIf="isVideoQuizFound && isUserRole!==1"
                                  style="position: relative; display: block"
                                >
                                  <div id="seek-bar-container">
                                    <div id="seek-bar">
                                      <div id="current-time">
                                        <div
                                          class="bubles"
                                          *ngFor="let percent of markerSeekBar"
                                          [ngStyle]="{ left: percent }"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> -->
                            </div>
                            <ng-template #elseMediaTemplate>
                              <vg-player style="height: 490px" *ngIf="mediaContent.file_type === 'audio'"
                                (onPlayerReady)="videoPlayerInit($event)">
                                <vg-overlay-play></vg-overlay-play>
                                <vg-buffering></vg-buffering>

                                <vg-controls>
                                  <vg-play-pause></vg-play-pause>
                                  <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

                                  <vg-scrub-bar>
                                    <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                                    <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                                  </vg-scrub-bar>

                                  <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

                                  <vg-mute></vg-mute>
                                  <vg-volume></vg-volume>

                                  <vg-fullscreen></vg-fullscreen>
                                </vg-controls>

                                <audio #audio [vgMedia]="audio" id="myAudio" preload="none">
                                  <source [src]="inputSrc" [type]="'audio/mpeg'" />
                                </audio>
                              </vg-player>
                            </ng-template>
                          </div>
                        </div>
                        <ng-template #elseTemplate>
                          <div class="" *ngIf="
                              mediaContent.file_type === 'image';
                              else elseTemplate
                            ">
                            <img class="thumb_img" [src]="mediaContent.view_Url" [ngxWatermark]="options" />
                          </div>
                          <ng-template #elseTemplate>
                            <!-- <div class="">
                              <div
                                class="mediaDocFile"
                                *ngFor="let ic of uploadFileIcons"
                              >
                                <div
                                  class="imgFigure"
                                  *ngIf="ic.name === mediaContent.file_ext"
                                >
                                  <div class="watermark_title">
                                    <p class="bg-text">
                                      {{ mediaContent.watermark }}
                                    </p>
                                  </div>
                                  <figure class="is-centered is-mobile is-desktop">
                                    <img class="tile_imgcenter" [src]="ic.icons" />
                                  </figure>
                                  <a
                                    class="button is-link is-outlined thumb_play is-small"
                                    (click)="
                                      secureFileViewed(
                                        mediaContent.message_id,
                                        mediaContent
                                      )
                                    "
                                  >
                                    <i
                                      class="fa"
                                      [ngClass]="{
                                        'fa-eye': mediaContent.file_type != 'audio',
                                        'fa-play-circle-o':
                                          mediaContent.file_type === 'audio'
                                      }"
                                      aria-hidden="true"
                                    ></i>
                                    View Docment
                                  </a>
                                </div>
                              </div>
                            </div> -->
                            <div style="height: 600px">
                              <span class="is-loading" *ngIf="showFileLoadSpinner"
                                style="position: absolute; top: 35%; left: 43%">
                                <img src="../../../../../../assets/images/loader-dot-small.gif" alt="" />
                              </span>

                              <ngx-doc-viewer url="{{ selectedReadFile }}" viewer="google"
                                googleCheckContentLoaded="true" googleCheckInterval="3000" googleMaxChecks="5"
                                style="width: 100%; height: 600px; z-index: 999">
                              </ngx-doc-viewer>
                              <!-- <button
                                class="modal-close is-large"
                                aria-label="close"
                                (click)="hideReadFile(mesgIds)"
                              ></button> -->
                            </div>
                          </ng-template>
                        </ng-template>
                        <div class="columns">
                          <div class="column is-9">
                            <p class="is-size-6 title is-7 is-capitalized" title="{{ mediaContent.message }}"
                              [innerHTML]="mediaContent.message"></p>
                            <p class="shared">
                              {{ mediaContent.shared_by }} -
                              {{ mediaContent.created_at | date: "MMM d, y" }}
                            </p>
                          </div>
                          <div class="column" *ngIf="isUserRole != 1">
                            <div *ngIf="
                                mediaContent.is_download ||
                                mediaContent.is_polls_found ||
                                mediaContent.is_survey_found ||
                                mediaContent.is_question_found
                              ">
                              <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                                <div class="dropdown is-right" [ngClass]="{
                                    'is-active': show && dropdownIndex === $index
                                  }">
                                  <div class="dropdown-trigger" (click)="clickit($event, $index)">
                                    <a class="is-small pad-5-10">
                                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                    </a>
                                  </div>
                                  <div class="dropdown-menu" id="dropdown-menu6" role="menu"
                                    (click)="$event.stopPropagation()">
                                    <div class="dropdown-content">
                                      <a class="dropdown-item" *ngIf="is_question_found" (click)="
                                          loadAssessmentQuiz(
                                            mediaContent.messageId,
                                            'question'
                                          )
                                        ">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                        Assessment Test
                                      </a>
                                      <a class="dropdown-item" *ngIf="is_survey_found" (click)="
                                          loadAssessmentQuiz(
                                            mediaContent.messageId,
                                            'survey'
                                          )
                                        ">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                        Survey Quiz
                                      </a>
                                      <a class="dropdown-item" *ngIf="is_polls_found" (click)="
                                          loadAssessmentQuiz(
                                            mediaContent.messageId,
                                            'polls'
                                          )
                                        ">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                        Poll Quiz
                                      </a>
                                      <a class="dropdown-item" *ngIf="mediaContent.is_download"
                                        (click)="secureFileDownLoad(mediaContent)">
                                        <i class="fa fa-download" aria-hidden="true"></i>
                                        Download
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <nav class="pagination is-small" role="navigation" aria-label="pagination">
                          <button class="button is-outlined pagination-previous" [disabled]="
                              prevDisabled || this.classFileList.length === 1
                            " (click)="getPreVideo(currentIndex)">
                            Previous
                          </button>
                          <button class="button is-outlined pagination-next mar-5" [disabled]="
                              nextDisabled || this.classFileList.length === 1
                            " (click)="getNextVideo(currentIndex)">
                            Next
                          </button>
                        </nav>
                        <h3 *ngIf="mediaContent.description" class="title is-3 descHeading">
                          Description
                        </h3>
                        <div [innerHTML]="mediaContent.description"></div>
                      </div>
                    </div>
                    <div *ngIf="activeModalSelectFile[mesgIds]" style="width: 100%">
                      <span class="is-loading is-3" *ngIf="showFileLoadSpinner"><strong>Loading...</strong></span>
                      <ngx-doc-viewer class="ngxDocViewer" queryParams="h1=N1" popout-hide="none" viewer="google"
                        googleCheckContentLoaded="true" googleCheckInterval="3000" googleMaxChecks="5"
                        [url]="selectedReadFile" style="width: 100%; height: 80vh; z-index: 999"></ngx-doc-viewer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="card events-card">
                <nav class="tabs is-info is-outlined is-boxed is-fullwidth is-small">
                  <div class="container">
                    <ul style="font-size: 15px">
                      <li class="tab is-active" (click)="openTab($event, 'lessons')">
                        <a>Policy</a>
                      </li>
                      <li class="tab" *ngIf="isUserRole != 1" (click)="openTab($event, 'notes')">
                        <a>Notes</a>
                      </li>
                    </ul>
                  </div>
                </nav>

                <div class="container">
                  <div id="lessons" class="content-tab">
                    <div class="card-table">
                      <div class="content">
                        <div class="list-wrapper scroll-bar list-overflow" appInfiniteScroll infinite-scroll
                          [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
                          [scrollWindow]="false" (scrolled)="fetchElibraryVideoList()">
                          <ul class="notification-list">
                            <li class="cursor-pointer pos-relative chat-list"
                              *ngFor="let vdo of classFileList; let $index = index"
                              (click)="startPlayListVdo($index, vdo)" [ngClass]="{
                                selectedActive:
                                  vdo === currentVideo ||
                                  vdo.message_id === currentVideoId
                              }">
                              <div class="columns is-gapless is-clearfix pos-relative display-flex">
                                <div class="column is-clearfix">
                                  <p class="is-size-6 title list-active is-7 is-capitalized" [title]="vdo.message">
                                    {{ vdo.message ? vdo.message : "No Title" }}
                                  </p>
                                  <p class="shared">
                                    {{ vdo.shared_by }} -
                                    {{ vdo.created_at | date: "MMM d, y" }}
                                  </p>
                                </div>
                                <div class="field is-small" *ngIf="currentVideoId">
                                  <input class="is-checkradio is-small is-success is-circle" id="checkbox"
                                    type="checkbox" [checked]="vdo.message_id === currentVideoId" disabled />
                                  <label for="checkbox"></label>
                                </div>
                              </div>
                            </li>
                            <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="notes" class="content-tab" style="display: none" *ngIf="isUserRole != 1">
                    <div *ngIf="is_notes; else elseIsNotesTemplate">
                      <form [formGroup]="userNotesForm">
                        <div class="scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true"
                          [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
                          <div class="cardcontent scroll-bar pos-relative" appInfiniteScroll infinite-scroll
                            [scrollWindow]="true" [infiniteScrollDistance]="modalScrollDistance"
                            [infiniteScrollThrottle]="modalScrollThrottle">
                            <div class="notes-form" style="padding: 10px" *ngFor="let item of userNotes; let i = index">
                              <h3 class="notesFormHeading is-size-6 label mar-0-10">
                                {{ i + 1 }}. <span [innerHTML]="item.question"></span>
                              </h3>
                              <input type="hidden" id="{{ item.question_id }}" name="question_id"
                                formControlName="question_id" value="{{ item.question_id }}" />
                              <input type="hidden" id="{{ item.user_notes_id }}" name="user_notes_id"
                                formControlName="user_notes_id" value="{{ item.user_notes_id }}" />
                              <!-- <angular-editor class="scroll-bar" id="{{item.question_id}}" [config]="editorConfig" cols="10" rows="2" formControlName="user_notes" (change)="changeEventUserNotes(item, userNotesForm.value)"></angular-editor> -->
                              <textarea name="notes" class="textarea" id="user_notes_{{ item.question_id }}" cols="30"
                                rows="5" placeholder="Enter the short answer here..." formControlName="notes" (change)="
                                  changeEventUserNotes(item, userNotesForm.value)
                                " [value]="item.notes ? item.notes : ''"></textarea>
                            </div>
                          </div>
                          <footer class="card-footer">
                            <div class="columns is-12" style="width: 100%; padding: 12px 0px">
                              <div class="column is-6 has-text-left">
                                <a class="button mar-0-5 is-link is-small has-tooltip-right"
                                  data-tooltip="Download Notes" (click)="userNotesDownload(this.userNotes)">
                                  <i class="fa fa-download" aria-hidden="true"></i>
                                </a>
                              </div>
                              <div class="column is-6 has-text-right">
                                <!-- <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0" (click)="clearUserNotes()">Clear</button> -->
                                <button type="button" class="actBtnMobileView button is-link is-small disabledBtn"
                                  [disabled]="
                                    (userNotesForm.valid && !userNotesForm.dirty) ||
                                    userNotesForm.invalid
                                  " (click)="
                                    updatedUserNotes(userNotesForm.value, msgIds)
                                  " *ngIf="!showBtnSpinner && userNotes.length > 0">
                                  Update Notes
                                </button>
                                <button type="button" class="actBtnMobileView button is-link is-small disabledBtn"
                                  [disabled]="
                                    (userNotesForm.valid && !userNotesForm.dirty) ||
                                    userNotesForm.invalid
                                  " (click)="
                                    submitUserNotes(userNotesForm.value, msgIds)
                                  " *ngIf="!showBtnSpinner && userNotes.length === 0">
                                  Save Notes
                                </button>

                                <a class="button is-link is-loading is-small" style="min-width: 100px"
                                  *ngIf="showBtnSpinner"></a>
                              </div>
                            </div>
                          </footer>
                        </div>
                      </form>
                    </div>
                    <ng-template #elseIsNotesTemplate>
                      <form [formGroup]="userNotesForm">
                        <div class="scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true"
                          [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
                          <div class="notes-form" style="padding: 10px">
                            <input type="hidden" class="input" name="user_notes_id" formControlName="user_notes_id" />
                            <angular-editor class="scroll-bar" id="notes" [config]="editorIsNotesConfig" cols="10"
                              rows="2" formControlName="notes"></angular-editor>
                          </div>
                          <footer class="card-footer">
                            <div class="columns is-12" style="width: 100%; padding: 12px 0px">
                              <div class="column is-6 has-text-left">
                                <a class="button mar-0-5 is-link is-small has-tooltip-right"
                                  data-tooltip="Download Notes" (click)="userNotesDownload(this.userNotes)">
                                  <i class="fa fa-download" aria-hidden="true"></i>
                                </a>
                              </div>
                              <div class="column is-6 has-text-right">
                                <!-- <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0" (click)="clearUserNotes()">Clear</button> -->
                                <button type="button" class="actBtnMobileView button is-link is-small disabledBtn"
                                  [disabled]="
                                    (userNotesForm.valid && !userNotesForm.dirty) ||
                                    userNotesForm.invalid
                                  " (click)="
                                    submitUserNotes(userNotesForm.value, msgIds)
                                  " *ngIf="!showBtnSpinner && userNotes.length === 0">
                                  Save Notes
                                </button>
                                <button type="button" class="actBtnMobileView button is-link is-small disabledBtn"
                                  [disabled]="
                                    (userNotesForm.valid && !userNotesForm.dirty) ||
                                    userNotesForm.invalid
                                  " (click)="
                                    updatedUserNotes(userNotesForm.value, msgIds)
                                  " *ngIf="!showBtnSpinner && userNotes.length > 0">
                                  Update Notes
                                </button>
                                <a class="button is-link is-loading is-small" style="min-width: 100px"
                                  *ngIf="showBtnSpinner"></a>
                              </div>
                            </div>
                          </footer>
                        </div>
                      </form>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <footer class="modal-card-foot">


      </footer>
    </div>
  </div>


  <!---Questionnarie-->
  <div class="library_tile_view" style="display: none;" *ngIf="!viewControl.showHideEditFileUpload">
    <div class="flex-container editedFileUpload">
      <div class="flex-item" style="width: 100%">
        <div class="card scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true"
          [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
          <!-- <div class="card-header">
            <p class="card-header-title">Edit lesson</p>
          </div> -->
          <div class="tabs mb-2 is-info is-outlined is-fullwidth is-small questionariesTab">
            <ul>
              <!-- <li class="is-active"><a>Interactive video</a></li> -->
              <li class="tab is-active" (click)="openTab($event, 'lesson')">
                <a>Policy</a>
              </li>
              <li class="tab" (click)="openTab($event, 'assessment')">
                <a>Assessment</a>
              </li>
              <li class="tab" (click)="openTab($event, 'survey')">
                <a>Survey</a>
              </li>
              <li class="tab" (click)="openTab($event, 'poll')">
                <a>Poll</a>
              </li>
              <li class="tab" (click)="openTab($event, 'notes')">
                <a>Notes</a>
              </li>
            </ul>
          </div>
          <div class="card-body mt-1 py-0">
            <form [formGroup]="editQuizForm" novalidate>
              <div class="pos-relative" infinite-scroll>
                <div class="row">
                  <div class="col is-clearfix">
                    <!-- <div class="column is-5" style="display: none;">
                    <div class="field post-attach-file">
                     
                    <label class="label" *ngIf="uploadAttachFile">Attached File</label>
                      <div
                        class="control file is-fullwidth is-info-light"
                        *ngIf="!preUploadedFile && !uploadAttachFile"
                      >
                        <label class="file-label">
                          <input
                            type="file"
                            name="msg-file"
                            style="display: none"
                            #topicFileInput
                            (change)="onFileChange($event)"
                            accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .pptm, .xml, .xls, .xlsx, .doc, .docx, .txt"
                          />
                          <span class="file-cta">
                            <span class="file-icon">
                              <i class="fa fa-upload"></i>
                            </span>
                            <span class="file-label is-small is-centered">
                              Upload a file…
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div *ngIf="upLoadedFileList.length > 0">
                   
                      <div
                        class="pos-relative"
                        *ngFor="let eachFile of upLoadedFileList"
                      >
                        <div class="file-detail">
                          <div class="content-align">
                            <p>
                              <img
                                src="../../../../assets/images/file_types/{{
                                  eachFile.mimeType
                                }}.png"
                                width="35px"
                                height="35px"
                              />
                              {{ eachFile.name }}
                            </p>
                            <span class="file-size is-small">{{
                              eachFile.size | fileSize
                            }}</span>
                            <progress
                              class="progress is-link is-small"
                              value="{{ eachFile.progressVal }}"
                              max="100"
                              *ngIf="eachFile.progressVal"
                            ></progress>
                          </div>
                        </div>
            
                      </div>
                    </div>
                    <div
                      class="is-small"
                      *ngIf="
                        preUploadedFile && uploadAttachFile;
                        else elseTemplate
                      "
                    >
                      <div *ngFor="let f of uploadFileIcons">
                        <span *ngIf="f.name === preUploadedFile.file_ext">
                          <img
                            [src]="f.icons"
                            alt=""
                            width="35px"
                            height="35px"
                          />{{ preUploadedFile.file_id }}

                          <button
                            class="delete"
                            aria-label="Delete"
                            title="Remove upload file"
                            (click)="
                              removeUploadFile(
                                upLoadedFileList,
                                editedData['duration']
                              )
                            "
                          ></button>
                        </span>
                      </div>
                    </div>
                    <ng-template #elseTemplate>
                      <div
                        *ngIf="
                          uploadAttachFile && upLoadedFileList.length === 0
                        "
                      >
                        <span>
                          <p>
                            <img
                              src="../../../../assets/images/file_types/{{
                                editedData['file_ext']
                              }}.png"
                              width="35px"
                              height="35px"
                            />
                            {{ editedData["file_id"] }}
                            <button
                              class="delete"
                              aria-label="Delete"
                              title="Remove existing file"
                              (click)="
                                removeExitingFile(
                                  editedData['file_id'],
                                  editedData['duration']
                                )
                              "
                            ></button>
                          </p>
                        </span>
                      </div>
                    </ng-template>
                    <div class="field">
                      <label class="label">Duration</label>
                      <div class="control">
                        <input
                          class="input"
                          type="text"
                          id="fileDuration"
                          name="duration"
                          placeholder="Video/Audio File Duration"
                          #durationInput
                          formControlName="duration"
                          [readonly]="true"
                        />
                      </div>
                    </div>
                    <div class="field responsiveRadioBtn">
                      <input
                        id="switchDownload"
                        type="checkbox"
                        name="is_download"
                        class="switch is-small is-success"
                        formControlName="is_download"
                        [(ngModel)]="isDownload"
                      />
                      <label for="switchDownload">Allow download?</label>
                    </div>
                       <div class="field responsiveRadioBtn">
                      <input
                        id="switchPublish"
                        type="checkbox"
                        name="is_publish"
                        class="switch is-small is-success"
                        formControlName="is_publish"
                        [(ngModel)]="isPublish"
                      />
                      <label for="switchPublish">Publish this lesson?</label>
                    </div>   
                    <div class="field">
                      <label class="label"
                        >Title
                        <span class="required">*</span>
                      </label>
                      <div class="control">
                        <input
                          class="input"
                          type="text"
                          name="title"
                          [(ngModel)]="editedData['message']"
                          placeholder="Title"
                          formControlName="message"
                        />
                      </div>
                    </div>

                    <div class="field">
                      <label class="label">Description</label>
                      <div class="control">
                        <angular-editor
                          class="scroll-bar"
                          [config]="editorConfig"
                          cols="10"
                          rows="2"
                          formControlName="description"
                        ></angular-editor>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label">Price $</label>
                          <div class="control">
                            <input
                              type="text"
                              class="input"
                              name="price"
                              [(ngModel)]="editedData['price']"
                              placeholder="Price $ 0.00"
                              formControlName="price"
                              (keypress)="numberOnlyValidator($event)"
                              (keydown)="IsDecimalValue($event)"
                            />
                            <p
                              class="is-small has-text-danger"
                              *ngIf="priceValidate"
                            >
                              {{ priceErrMsg }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <label class="label">Discount %</label>
                          <div class="control">
                            <input
                              type="text"
                              class="input"
                              name="discount"
                              [(ngModel)]="editedData['discount']"
                              placeholder="Discount"
                              formControlName="discount"
                              (keypress)="isNumberKey($event)"
                              maxlength="3"
                              (keyup)="discountPercentage($event)"
                            />
                            <p
                              class="is-small has-text-danger"
                              *ngIf="discountValidate"
                            >
                              {{ priceErrMsg }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="field" style="display: none;">
                      <label class="label">Watermark Title</label>
                      <div class="control">
                        <input
                          type="text"
                          class="input"
                          name="watermark_title"
                          [(ngModel)]="editedData['water_mark_title']"
                          placeholder="Watermark Title"
                          formControlName="water_mark_title"
                        />
                      </div>
                    </div>
                  </div> -->


                    <div id="lesson" class="content-tab row">
                      <div class="col-md-6">
                        <div class="field post-attach-file">
                          <!-- <video loop autoplay>
                              <source [src]="inputSrc" type="video/mp4">
                          </video> -->
                          <label class="label" *ngIf="uploadAttachFile">Attached File</label>
                          <div class="control file is-fullwidth is-info-light"
                            *ngIf="!preUploadedFile && !uploadAttachFile">
                            <label class="file-label">
                              <input type="file" name="msg-file" style="display: none" #topicFileInput
                                (change)="onFileChange($event)"
                                accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .pptm, .xml, .xls, .xlsx, .doc, .docx, .txt" />
                              <span class="file-cta">
                                <span class="file-icon">
                                  <i class="fa fa-upload"></i>
                                </span>
                                <span class="file-label is-small is-centered">
                                  Upload a file…
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div *ngIf="upLoadedFileList.length > 0">

                          <div class="pos-relative" *ngFor="let eachFile of upLoadedFileList">
                            <div class="file-detail">
                              <div class="content-align">
                                <p>
                                  <img src="../../../../assets/images/file_types/{{
                                        eachFile.mimeType
                                      }}.png" width="35px" height="35px" />
                                  {{ eachFile.name }}
                                </p>
                                <span class="file-size is-small">{{
                                  eachFile.size | fileSize
                                  }}</span>
                                <progress class="progress is-link is-small" value="{{ eachFile.progressVal }}" max="100"
                                  *ngIf="eachFile.progressVal"></progress>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="is-small" *ngIf="
                              preUploadedFile && uploadAttachFile;
                              else elseTemplate
                            ">
                          <div *ngFor="let f of uploadFileIcons">
                            <span *ngIf="f.name === preUploadedFile.file_ext">
                              <img [src]="f.icons" alt="" width="35px" height="35px" />{{ preUploadedFile.file_id }}

                              <button class="delete" aria-label="Delete" title="Remove upload file" (click)="
                                    removeUploadFile(
                                      upLoadedFileList,
                                      editedData['duration']
                                    )
                                  "></button>
                            </span>
                          </div>
                        </div>
                        <ng-template #elseTemplate>
                          <div *ngIf="
                                uploadAttachFile && upLoadedFileList.length === 0
                              ">
                            <span>
                              <p>
                                <img src="../../../../assets/images/file_types/{{
                                      editedData['file_ext']
                                    }}.png" width="35px" height="35px" />
                                {{ editedData["file_id"] }}
                                <button class="delete" aria-label="Delete" title="Remove existing file" (click)="
                                      removeExitingFile(
                                        editedData['file_id'],
                                        editedData['duration']
                                      )
                                    "></button>
                              </p>
                            </span>
                          </div>
                        </ng-template>
                        <div class="field">
                          <label class="label">Duration</label>
                          <div class="control">
                            <input class="input" type="text" id="fileDuration" name="duration"
                              placeholder="Video/Audio File Duration" #durationInput formControlName="duration"
                              [readonly]="true" />
                          </div>
                        </div>

                        <!-- <div class="field responsiveRadioBtn">
                            <input
                              id="switchPublish"
                              type="checkbox"
                              name="is_publish"
                              class="switch is-small is-success"
                              formControlName="is_publish"
                              [(ngModel)]="isPublish"
                            />
                            <label for="switchPublish">Publish this lesson?</label>
                          </div>   -->
                        <div class="field">
                          <label class="label">Title
                            <span class="required">*</span>
                          </label>
                          <div class="control">
                            <input class="input" type="text" name="title" [(ngModel)]="editedData['message']"
                              placeholder="Title" formControlName="message" />
                          </div>
                        </div>
                        <div class="field responsiveRadioBtn">
                          <input id="switchDownload" type="checkbox" name="is_download"
                            class="switch is-small is-success" formControlName="is_download" [(ngModel)]="isDownload" />
                          <label for="switchDownload">Allow download?</label>
                        </div>

                        <div class="field" style="display: none;">
                          <label class="label">Watermark Title</label>
                          <div class="control">
                            <input type="text" class="input" name="watermark_title"
                              [(ngModel)]="editedData['water_mark_title']" placeholder="Watermark Title"
                              formControlName="water_mark_title" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="field">
                          <label class="label">Description</label>
                          <div class="control">
                            <angular-editor class="scroll-bar" [config]="editorConfig" cols="10" rows="2"
                              formControlName="description"></angular-editor>
                          </div>
                        </div>


                        <div class="field" style="display: none;">
                          <label class="label">Price $</label>
                          <div class="control">
                            <input type="text" class="input" name="price" [(ngModel)]="editedData['price']"
                              placeholder="Price $ 0.00" formControlName="price"
                              (keypress)="numberOnlyValidator($event)" (keydown)="IsDecimalValue($event)" />
                            <p class="is-small has-text-danger" *ngIf="priceValidate">
                              {{ priceErrMsg }}
                            </p>
                          </div>
                        </div>


                        <div class="field" style="display: none;">
                          <label class="label">Discount %</label>
                          <div class="control">
                            <input type="text" class="input" name="discount" [(ngModel)]="editedData['discount']"
                              placeholder="Discount" formControlName="discount" (keypress)="isNumberKey($event)"
                              maxlength="3" (keyup)="discountPercentage($event)" />
                            <p class="is-small has-text-danger" *ngIf="discountValidate">
                              {{ priceErrMsg }}
                            </p>
                          </div>
                        </div>




                      </div>
                    </div>

                    <div id="assessment" class="content-tab row" style="display: none;">

                      <div class="col-12">
                        <div class="row">
                          <div class="col-12">
                            <div class="row pull-right">
                              <div class="col">
                                <div class="field">
                                  <label class="label">Minimum % required</label>
                                  <div class="control">
                                    <input type="text" class="input" name="min_percentage" placeholder="%"
                                      formControlName="min_percentage" />
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <label class="label has-text-weight-bold">Allow to Re-Test?</label>
                                <div class="field responsiveRadioBtn">
                                  <input id="switchReTest" type="checkbox" name="is_allow_retest"
                                    class="switch is-small is-success" formControlName="is_allow_retest"
                                    [(ngModel)]="isAllowRetest" />
                                  <label for="switchReTest"></label>
                                </div>
                              </div>
                              <div class="col-auto">
                                <div class="field">
                                  <label class="label">No.of Random Question
                                    <span class="required">*</span></label>
                                  <div class="control">
                                    <input type="text" class="input" name="random_question" placeholder=""
                                      formControlName="random_question" (keydown)="keyDownHandler($event)"
                                      (keypress)="numericOnlyHandler($event)" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-3">
                            <a class="button is-link is-small has-tooltip-top mar-0-5"
                              *ngIf="domElementControl.showCreateNewQuestions" data-tooltip="Add your first question"
                              (click)="onCreateAssQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                              Add your assessment question
                            </a>
                          </div>
                        </div>
                        <div class="row">

                          <!-- <ng-container formArrayName="assessment">
                                <div class="questionnarie row"  *ngFor="
                                let assessmentCtrl of assQuestion().controls;
                                let questIndex = index">
                                <div [formGroupName]="questIndex">
                                  <div class="col">
                                    <div class="row">
                                      <div class="question-choice col-md-3">
                                      <div class="field">
                                        <div class="label">
                                          <label class="label"
                                            >Question Type
                                            <span class="required"> *</span>
                                          </label>
                                            <span class="control">
                                              <div
                                                class="radio"
                                                *ngFor="
                                                  let item of questions;
                                                  let i = index
                                                "
                                              >
                                                <input
                                                  [value]="item.value"
                                                  [id]="i"
                                                  formControlName="answer_type"
                                                  type="radio"
                                                  (click)="
                                                    onSelectedType(item, questIndex)
                                                  "
                                                />
                                                {{ item.viewValue }}
                                              </div>
                                            </span>
                                           
                                       
                                        </div>
                                     
                                      </div>
                                      </div>
                                      <div class="field col-md-3 pull-left">
                                       <label class="label has-text-weight-bold">Mark &nbsp;<span class="required"> *</span></label> 
                                        <div class="control">
                                          <input
                                            type="text"
                                            class="input"
                                            name="mark"
                                            id="mark_{{ questIndex }}"
                                            placeholder="Enter the mark"
                                            formControlName="mark"
                                            (keydown)="keyDownHandler($event)"
                                            (keypress)="
                                              numericOnlyHandler($event)
                                            "
                                          />
                                          <div
                                            *ngIf="
                                              (assessmentCtrl.get('mark')
                                                .touched ||
                                                assessmentCtrl.get('mark')
                                                  .dirty) &&
                                              assessmentCtrl.get('mark').invalid
                                            "
                                          >
                                            <div
                                              class="has-text-danger is-size-7"
                                              *ngIf="assessmentCtrl.get('mark').hasError('whitespace')"
                                            >
                                              Mark is required
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                   <div class="col">
                                    <label class="label has-text-weight-bold">Question</label>
                                   
                                   <div class="col">
                                    <input
                                    type="text"
                                    name="question"
                                    id="question_{{ questIndex }}"
                                    class="input"
                                    placeholder="Enter the question"
                                    formControlName="question"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  
                                  <a
                                  class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                  data-tooltip="Remove Question"
                         
                                  (click)="removeAssQuestion(questIndex)"
                                >
                                  <i class="fa fa-times-circle mar-0-5"></i>
                                </a> 
                                   </div> 
                                   <div class="col">
                                    <div
                                    *ngIf="
                                      (assessmentCtrl.get('question').touched ||
                                        assessmentCtrl.get('question').dirty) &&
                                      assessmentCtrl.get('question').invalid
                                    "
                                  >
                                    <div
                                      class="has-text-danger is-size-7"
                                      *ngIf="
                                        assessmentCtrl
                                          .get('question')
                                          .hasError('whitespace')
                                      "
                                    >
                                      Question is required
                                    </div>
                                  </div>
                               
                                   </div>
                            
                                   <div class="row">
                                    <div class="question-option col-10 pull-right mt-2  ms-2"
                                   formArrayName="answer"
                                   *ngIf="isShown[questIndex]"
                                 >
                                 <label class="label has-text-weight-bold">Answers</label>
                                 <div
                                 class="control"
                                 *ngFor="
                                   let answerCtrl of assQuestAnswers(
                                     questIndex
                                   ).controls;
                                   let optionIndex = index
                                 ">
                                
                                 <div
                                   class=""
                                   [formGroupName]="optionIndex"
                                 >
                                   <input
                                     type="text"
                                     name="answer"
                                     class="input"
                                     id="answer_{{ optionIndex }}"
                                     placeholder="Enter the answer"
                                     formControlName="answer"
                                   />
                                   <input
                                     type="hidden"
                                     name="answer_id"
                                     class="input"
                                     id="answer_id_{{ optionIndex }}"
                                     placeholder="Enter the answer"
                                     formControlName="answer_id"
                                   />
                                   <input
                                     type="radio"
                                     class="is-checkradio"
                                     [ngClass]="{
                                       'is-danger':
                                         selectedOptions[questIndex]
                                     }"
                                     name="is_correct_answer{{
                                       questIndex
                                     }}"
                                     id="correctAnswer_{{
                                       questIndex
                                     }}-{{ optionIndex }}"
                                     [checked]="answerCtrl.value.is_correct_answer"
                                     value="{{ isChecked }}"
                                     (click)="
                                       onCheckedAnswer(
                                         $event,
                                         assessmentCtrl,
                                         questIndex,
                                         optionIndex
                                       )
                                     "
                                   />
                                   <label
                                     for="correctAnswer_{{
                                       questIndex
                                     }}-{{ optionIndex }}"
                                     title="Check correct answer"
                                   ></label>
                                   <a
                                     class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                     data-tooltip="Remove Answer"
                                     *ngIf="
                                       assQuestAnswers(questIndex)
                                         .controls.length > 1
                                     "
                                     (click)="
                                       removeAssOptions(
                                         questIndex,
                                         optionIndex,
                                         answerCtrl
                                       )
                                     "
                                   >
                                     <i
                                       class="fa fa-times-circle"
                                       aria-hidden="true"
                                     ></i>
                                   </a>
                                   <div
                                     *ngIf="
                                       (answerCtrl.get('answer')
                                         .touched ||
                                         answerCtrl.get('answer')
                                           .dirty) &&
                                       answerCtrl.get('answer').invalid
                                     "
                                   >
                                     <div
                                       class="has-text-danger is-size-6"
                                       *ngIf="
                                         answerCtrl
                                           .get('answer')
                                           .hasError('whitespace')
                                       "
                                     >
                                       Answer is required
                                     </div>
                                   </div>
                                 </div>
                               </div>
                                   <a
                                     class="button is-link is-outlined is-small has-tooltip-top mt-1"
                                     data-tooltip="Add more choice"
                                     (click)="onCreateAssOption(questIndex)"
                                   >
                                     <i
                                       class=" fa-solid fa-circle-plus mar-0-5"
                                       aria-hidden="true"
                                     ></i>
                                     Add more choice
                                   </a>
                                    </div>
                                    <p
                                    class="has-text-danger is-small is-size-7"
                                    *ngIf="selectedOptions[questIndex]"
                                  >
                                    Please select any one answer
                                    </p>
                                   </div>   
                                   <div class="col mt-2 pull-right">
                                    <button
                                    class="button is-link is-outlined is-small has-tooltip-top"
                                    (click)="onCreateAssQuestion()"
                                  >
                                    <i
                                      class=" fa-solid fa-circle-plus mar-0-5"
                                      aria-hidden="true"
                                    ></i>
                                    Add new question
                                  </button>
                                  </div>
                                   
                                  </div>
                                </div>
                                </div>
                              </ng-container> -->
                        </div>

                      </div>


                      <div class="col-12">
                        <div class="row">
                          <div class="col-3">
                            <a class="button is-link is-small has-tooltip-top mar-0-5"
                              *ngIf="!domElementControl.showCreateNewQuestions" data-tooltip="Add your first question"
                              (click)="onCreateAssQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                              Add your assessment question
                            </a>
                          </div>
                        </div>
                        <div class="row" *ngIf="
                                domElementControl.showCreateNewQuestions &&
                                is_question_found
                              ">


                          <div class="row">

                            <ng-container formArrayName="assessment">
                              <div class="questionnarie row" *ngFor="
                                      let assessmentCtrl of assQuestion()
                                        .controls;
                                      let questIndex = index
                                    ">
                                <div [formGroupName]="questIndex">
                                  <div class="col">
                                    <div class="row">
                                      <div class="question-choice col-md-3">
                                        <label class="form-label"><b>Question Type</b>
                                          <span class="required"> *</span>
                                          &nbsp;&nbsp;
                                        </label>
                                        <br>
                                        <span class="radio" *ngFor="
                                            let item of questions;
                                            let i = index
                                          ">
                                          <input [value]="item.value" [id]="i" formControlName="answer_type"
                                            type="radio" (click)="
                                              onSelectedType(
                                                item,
                                                questIndex
                                              )
                                            " />
                                          {{ item.viewValue }}
                                        </span>
                                      </div>
                                      <div class="field col-md-3 pull-left">
                                        <label class="label">Mark</label>
                                        <div class="field">
                                          <div class="control">
                                            <input type="text" class="input" [ngClass]="{
                                                    'is-danger':
                                                      markOptions[questIndex]
                                                  }" name="mark" id="mark_{{ questIndex }}"
                                              placeholder="Enter the mark" formControlName="mark" (keypress)="
                                                    numericOnlyHandler($event)
                                                  " />
                                            <div *ngIf="
                                                    (assessmentCtrl.get('mark')
                                                      .touched ||
                                                      assessmentCtrl.get('mark')
                                                        .dirty) &&
                                                    assessmentCtrl.get('mark')
                                                      .invalid
                                                  ">
                                              <div class="has-text-danger is-size-6" *ngIf="
                                                      assessmentCtrl
                                                        .get('mark')
                                                        .hasError('whitespace')
                                                    ">
                                                Mark is required
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row align-items-center">
                                    <label class="label has-text-weight-bold">Question</label>
                                    <div class="col-12">
                                      <span class="col-9 pull-left">
                                        <input type="text" name="question" id="question_{{ questIndex }}" class="input"
                                          placeholder="Enter the question" formControlName="question" />
                                        <input type="hidden" name="question_id" id="question_id_{{ questIndex }}"
                                          class="input" placeholder="Enter the question"
                                          formControlName="question_id" />
                                      </span>
                                      <span class="pull-left ms-2">
                                        <a class="icon has-text-grey-lighter has-tooltip-left"
                                          data-tooltip="Remove Question" *ngIf="assQuestion().length > 0"
                                          (click)="removeAssQuestion(questIndex)">
                                          <i class="fa fa-times-circle mar-0-5"></i>
                                        </a>
                                      </span>
                                    </div>


                                  </div>
                                  <div *ngIf="
                                          (assessmentCtrl.get('question')
                                            .touched ||
                                            assessmentCtrl.get('question')
                                              .dirty) &&
                                          assessmentCtrl.get('question').invalid
                                        ">
                                    <div class="has-text-danger is-size-6" *ngIf="
                                            assessmentCtrl
                                              .get('question')
                                              .hasError('whitespace')
                                          ">
                                      Question is required
                                    </div>
                                  </div>



                                  <div class="question-option" [ngClass]="{
                                          questionOption:
                                            removeAnsClass[questIndex]
                                        }" formArrayName="answer">
                                    <label class="label has-text-weight-bold">Answers</label>
                                    <div class="control" *ngFor="
                                            let answerCtrl of assQuestAnswers(
                                              questIndex
                                            ).controls;
                                            let optionIndex = index
                                          ">
                                      <div class="" [formGroupName]="optionIndex">
                                        <input type="text" name="answer" class="input" id="answer_{{ optionIndex }}"
                                          placeholder="Enter the answer" formControlName="answer" />
                                        <input type="hidden" name="answer_id" class="input"
                                          id="answer_id_{{ optionIndex }}" placeholder="Enter the answer"
                                          formControlName="answer_id" />
                                        <input type="radio" class="is-checkradio" [ngClass]="{
                                                'is-danger':
                                                  selectedOptions[questIndex]
                                              }" name="is_correct_answer{{
                                                questIndex
                                              }}" id="correctAnswer_{{
                                                questIndex
                                              }}-{{ optionIndex }}" [checked]="
                                                answerCtrl.value.is_correct_answer
                                              " value="{{ isChecked }}" (click)="
                                                onCheckedAnswer(
                                                  $event,
                                                  assessmentCtrl,
                                                  questIndex,
                                                  optionIndex
                                                )
                                              " />
                                        <label for="correctAnswer_{{
                                                questIndex
                                              }}-{{ optionIndex }}" title="Check correct answer"></label>
                                        <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                          data-tooltip="Remove Answer" *ngIf="
                                                assQuestAnswers(questIndex)
                                                  .controls.length > 1
                                              " (click)="
                                                removeAssOptions(
                                                  questIndex,
                                                  optionIndex,
                                                  answerCtrl
                                                )
                                              ">
                                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                                        </a>
                                        <div *ngIf="
                                                (answerCtrl.get('answer')
                                                  .touched ||
                                                  answerCtrl.get('answer')
                                                    .dirty) &&
                                                answerCtrl.get('answer').invalid
                                              ">
                                          <div class="has-text-danger is-size-6" *ngIf="
                                                  answerCtrl
                                                    .get('answer')
                                                    .hasError('whitespace')
                                                ">
                                            Answer is required
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <a *ngIf="isShown[questIndex]" class="button is-link  is-small mb-2 has-tooltip-top"
                                      data-tooltip="Add more choice" (click)="onCreateAssOption(questIndex)">
                                      <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                      Add more choice
                                    </a>
                                  </div>

                                </div>
                                <p class="has-text-danger is-small is-size-6" *ngIf="selectedOptions[questIndex]">
                                  Please select any one answer
                                </p>
                              </div>
                              <div class="col mt-2 mb-2">
                                <button class="button pull-right is-link  is-small has-tooltip-top"
                                  (click)="onCreateAssQuestion()">
                                  <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                  Add new question
                                </button>
                              </div>
                              <!-- <a
                                    class="button is-link is-outlined is-small has-tooltip-top"
                                    data-tooltip="Add new question"
                                    (click)="onCreateAssQuestion()"
                                  >
                                    <i
                                      class=" fa-solid fa-circle-plus mar-0-5"
                                      aria-hidden="true"
                                    ></i>
                                    Add new question
                                  </a> -->
                            </ng-container>
                          </div>

                        </div>
                      </div>


                    </div>
                    <div id="survey" class="content-tab row" style="display: none">

                      <div class="col">
                        <div class="row">
                          <div class="col-3">
                            <a class="button is-link is-small has-tooltip-top"
                              *ngIf="!domElementControl.showCreateNewSurQuestion" (click)="onCreateSurveyQuestion()">
                              <i class="fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                              Add your survey question
                            </a>
                          </div>
                        </div>
                        <div class="row">
                          <ng-container *ngIf="domElementControl.showCreateNewSurQuestion && is_survey_found">
                            <ng-container formArrayName="survey">
                              <div class="questionnarie row"
                                *ngFor="let surveyCtrl of surveyQuestions().controls; let questIndex = index">
                                <div [formGroupName]="questIndex">
                                  <div class="col">
                                    <label class="label has-text-weight-bold">Question</label>
                                    <div class="col">
                                      <input type="text" name="question" id="question_{{ questIndex }}" class="input"
                                        placeholder="Enter the question" formControlName="question" />
                                      <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                        data-tooltip="Remove Question" *ngIf="
                                            surveyQuestions().controls.length > 0
                                          " (click)="
                                            onRemoveSurveyQuestion(questIndex)
                                          ">
                                        <i class="fa fa-times-circle mar-0-5"></i>
                                      </a>
                                    </div>
                                    <div class="col">
                                      <div *ngIf="
                                            (surveyCtrl.get('question').touched ||
                                              surveyCtrl.get('question').dirty) &&
                                            surveyCtrl.get('question').invalid
                                          ">
                                        <div class="has-text-danger is-size-6" *ngIf="
                                              surveyCtrl
                                                .get('question')
                                                .hasError('whitespace')
                                            ">
                                          Question is required
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col mt-2">
                                    <label class="label has-text-weight-bold">Answers</label>
                                    <div class="row">
                                      <div class="question-option col-10 pull-right ms-2" formArrayName="answer">
                                        <div class="control  mb-2" *ngFor="
                                              let answerCtrl of surveyOptions(
                                                questIndex
                                              ).controls;
                                              let optionIndex = index
                                            ">
                                          <div class="" [formGroupName]="optionIndex">
                                            <input type="text" name="answer" class="input" id="answer_{{ optionIndex }}"
                                              placeholder="Enter the answer" formControlName="answer" />
                                            <label for="correctAnswer_{{
                                                  questIndex
                                                }}-{{ optionIndex }}" title="Check correct answer"></label>
                                            <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                              data-tooltip="Remove Answer" *ngIf="
                                                  surveyOptions(questIndex).controls
                                                    .length > 1
                                                " (click)="
                                                  removeSurveyOptions(
                                                    questIndex,
                                                    optionIndex
                                                  )
                                                ">
                                              <i class="fa fa-times-circle" aria-hidden="true"></i>
                                            </a>
                                            <div *ngIf="
                                                  (answerCtrl.get('answer')
                                                    .touched ||
                                                    answerCtrl.get('answer')
                                                      .dirty) &&
                                                  answerCtrl.get('answer').invalid
                                                ">
                                              <div class="has-text-danger is-size-6" *ngIf="
                                                    answerCtrl
                                                      .get('answer')
                                                      .hasError('whitespace')
                                                  ">
                                                Answer is required
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <a class="button is-link is-small has-tooltip-top"
                                          data-tooltip="Add more choice" (click)="oncreateSurveyOptions(questIndex)">
                                          <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                          Add more choice
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col mt-2 mb-2 pull-right">
                                    <a class="button is-link is-small has-tooltip-top" data-tooltip="Add new question"
                                      (click)="onCreateSurveyQuestion()">
                                      <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                      Add new question
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </div>
                      <div class="field" style="display: none;">

                        <section class="section" *ngIf="domElementControl.showCreateNewSurQuestion && is_survey_found">
                          <div class="container" formArrayName="survey">
                            <div class="questionnarie" *ngFor="
                                    let surveyCtrl of surveyQuestions()
                                      .controls;
                                    let questIndex = index
                                  ">
                              <div class="" [formGroupName]="questIndex">
                                <input type="text" name="question" id="question_{{ questIndex }}" class="input"
                                  placeholder="Enter the question" formControlName="question" />
                                <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                  data-tooltip="Remove Question" *ngIf="
                                        surveyQuestions().controls.length > 0
                                      " (click)="
                                        onRemoveSurveyQuestion(questIndex)
                                      ">
                                  <i class="fa fa-times-circle mar-0-5"></i>
                                </a>
                                <div *ngIf="
                                        (surveyCtrl.get('question').touched ||
                                          surveyCtrl.get('question').dirty) &&
                                        surveyCtrl.get('question').invalid
                                      ">
                                  <div class="has-text-danger is-size-6" *ngIf="
                                          surveyCtrl
                                            .get('question')
                                            .hasError('whitespace')
                                        ">
                                    Question is required
                                  </div>
                                </div>
                                <div class="question-option" formArrayName="answer">
                                  <div class="control" *ngFor="
                                          let answerCtrl of surveyOptions(
                                            questIndex
                                          ).controls;
                                          let optionIndex = index
                                        ">
                                    <div class="" [formGroupName]="optionIndex">
                                      <input type="text" name="answer" class="input" id="answer_{{ optionIndex }}"
                                        placeholder="Enter the answer" formControlName="answer" />
                                      <label for="correctAnswer_{{
                                              questIndex
                                            }}-{{ optionIndex }}" title="Check correct answer"></label>
                                      <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                        data-tooltip="Remove Answer" *ngIf="
                                              surveyOptions(questIndex).controls
                                                .length > 1
                                            " (click)="
                                              removeSurveyOptions(
                                                questIndex,
                                                optionIndex
                                              )
                                            ">
                                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                                      </a>
                                      <div *ngIf="
                                              (answerCtrl.get('answer')
                                                .touched ||
                                                answerCtrl.get('answer')
                                                  .dirty) &&
                                              answerCtrl.get('answer').invalid
                                            ">
                                        <div class="has-text-danger is-size-6" *ngIf="
                                                answerCtrl
                                                  .get('answer')
                                                  .hasError('whitespace')
                                              ">
                                          Answer is required
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <a class="button is-link is-outlined is-small has-tooltip-top"
                                    data-tooltip="Add more choice" (click)="
                                          oncreateSurveyOptions(questIndex)
                                        ">
                                    <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                    Add more choice
                                  </a>
                                </div>
                              </div>
                            </div>
                            <a class="button is-link is-outlined is-small has-tooltip-top"
                              data-tooltip="Add new question" (click)="onCreateSurveyQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                              Add new question
                            </a>
                          </div>
                        </section>
                      </div>
                    </div>
                    <div id="poll" class="content-tab row" style="display: none">

                      <div class="col">
                        <div class="row">
                          <div class="col-3">
                            <a class="button is-link is-small has-tooltip-top mar-0-5" *ngIf="
                                  !domElementControl.showCreateNewPolQuestion
                                " data-tooltip="Add your first question" (click)="onCreatePollQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                              Add your poll question
                            </a>
                          </div>
                        </div>
                        <div class="row">
                          <ng-container *ngIf="domElementControl.showCreateNewPolQuestion &&
                               is_polls_found">
                            <ng-container formArrayName="polls">
                              <div class="questionnarie row" *ngFor="
                                  let pollCtrl of pollQuestions().controls;
                                  let questIndex = index
                                ">
                                <div [formGroupName]="questIndex">
                                  <div class="col">
                                    <label class="label has-text-weight-bold">Question</label>
                                    <div class="col">
                                      <input type="text" name="question" id="question_{{ questIndex }}" class="input"
                                        placeholder="Enter the question" formControlName="question" />
                                      <input type="hidden" name="question_id" id="question_id_{{ questIndex }}"
                                        class="input" placeholder="Enter the question" formControlName="question_id" />
                                      <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                        data-tooltip="Remove Question" *ngIf="
                                        pollQuestions().controls.length > 0
                                      " (click)="removePollQuestion(questIndex)">
                                        <i class="fa fa-times-circle mar-0-5"></i>
                                      </a>
                                    </div>
                                    <div class="col">
                                      <div *ngIf="
                                        (pollCtrl.get('question').touched ||
                                          pollCtrl.get('question').dirty) &&
                                        pollCtrl.get('question').invalid
                                      ">
                                        <div class="has-text-danger is-size-7" *ngIf="
                                          pollCtrl
                                            .get('question')
                                            .hasError('whitespace')
                                        ">
                                          Question is required
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col mt-2 ">
                                      <label class="label has-text-weight-bold">Answers</label>
                                      <div class="row">
                                        <div class="question-option col-10 pull-right  ms-2" formArrayName="answer">
                                          <div class="control mb-2" *ngFor="
                                            let answerCtrl of pollOptions(
                                              questIndex
                                            ).controls;
                                            let optionIndex = index
                                          ">
                                            <div class="" [formGroupName]="optionIndex">
                                              <input type="text" name="answer" class="input"
                                                id="answer_{{ optionIndex }}" placeholder="Enter the answer"
                                                formControlName="answer" />
                                              <input type="hidden" name="answer_id" class="input"
                                                id="answer_id_{{ optionIndex }}" placeholder="Enter the answer"
                                                formControlName="answer_id" />
                                              <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                                data-tooltip="Remove Answer" *ngIf="
                                                pollOptions(questIndex).controls
                                                  .length > 1
                                              " (click)="
                                                onRemovePollOptions(
                                                  questIndex,
                                                  optionIndex,
                                                  answerCtrl
                                                )
                                              ">
                                                <i class="fa fa-times-circle" aria-hidden="true"></i>
                                              </a>
                                              <div *ngIf="
                                                (answerCtrl.get('answer')
                                                  .touched ||
                                                  answerCtrl.get('answer')
                                                    .dirty) &&
                                                answerCtrl.get('answer').invalid
                                              ">
                                                <div class="has-text-danger is-size-7" *ngIf="
                                                  answerCtrl
                                                    .get('answer')
                                                    .hasError('whitespace')
                                                ">
                                                  Answer is required
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <a class="button is-link  is-small has-tooltip-top"
                                            data-tooltip="Add more choice" (click)="
                                            onCreatePollOptions(questIndex)
                                          ">
                                            <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                            Add more choice
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col mt-2 mb-2 pull-right">
                                      <a class="button is-link is-small has-tooltip-top" data-tooltip="Add new question"
                                        (click)="onCreatePollQuestion()">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add new question
                                      </a>
                                    </div>
                                  </div>








                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </div>


                      <div class="field" style="display: none;">
                        <a class="button is-link is-outlined is-small has-tooltip-top mar-0-5" *ngIf="
                                !domElementControl.showCreateNewPolQuestion
                              " data-tooltip="Add your first question" (click)="onCreatePollQuestion()">
                          <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                          Add your poll question
                        </a>
                        <section class="section" *ngIf="
                                domElementControl.showCreateNewPolQuestion &&
                                is_polls_found
                              ">
                          <div class="container" formArrayName="polls">
                            <div class="questionnarie" *ngFor="
                                    let pollCtrl of pollQuestions().controls;
                                    let questIndex = index
                                  ">
                              <div class="" [formGroupName]="questIndex">
                                <input type="text" name="question" id="question_{{ questIndex }}" class="input"
                                  placeholder="Enter the question" formControlName="question" />
                                <input type="hidden" name="question_id" id="question_id_{{ questIndex }}" class="input"
                                  placeholder="Enter the question" formControlName="question_id" />
                                <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                  data-tooltip="Remove Question" *ngIf="
                                        pollQuestions().controls.length > 0
                                      " (click)="removePollQuestion(questIndex)">
                                  <i class="fa fa-times-circle mar-0-5"></i>
                                </a>
                                <div *ngIf="
                                        (pollCtrl.get('question').touched ||
                                          pollCtrl.get('question').dirty) &&
                                        pollCtrl.get('question').invalid
                                      ">
                                  <div class="has-text-danger is-size-6" *ngIf="
                                          pollCtrl
                                            .get('question')
                                            .hasError('whitespace')
                                        ">
                                    Question is required
                                  </div>
                                </div>
                                <div class="question-option" formArrayName="answer">
                                  <div class="control" *ngFor="
                                          let answerCtrl of pollOptions(
                                            questIndex
                                          ).controls;
                                          let optionIndex = index
                                        ">
                                    <div class="" [formGroupName]="optionIndex">
                                      <input type="text" name="answer" class="input" id="answer_{{ optionIndex }}"
                                        placeholder="Enter the answer" formControlName="answer" />
                                      <input type="hidden" name="answer_id" class="input"
                                        id="answer_id_{{ optionIndex }}" placeholder="Enter the answer"
                                        formControlName="answer_id" />
                                      <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                        data-tooltip="Remove Answer" *ngIf="
                                              pollOptions(questIndex).controls
                                                .length > 1
                                            " (click)="
                                              onRemovePollOptions(
                                                questIndex,
                                                optionIndex,
                                                answerCtrl
                                              )
                                            ">
                                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                                      </a>
                                      <div *ngIf="
                                              (answerCtrl.get('answer')
                                                .touched ||
                                                answerCtrl.get('answer')
                                                  .dirty) &&
                                              answerCtrl.get('answer').invalid
                                            ">
                                        <div class="has-text-danger is-size-6" *ngIf="
                                                answerCtrl
                                                  .get('answer')
                                                  .hasError('whitespace')
                                              ">
                                          Answer is required
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <a class="button is-link is-outlined is-small has-tooltip-top"
                                    data-tooltip="Add more choice" (click)="
                                          onCreatePollOptions(questIndex)
                                        ">
                                    <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                    Add more choice
                                  </a>
                                </div>
                              </div>
                            </div>
                            <a class="button is-link is-outlined is-small has-tooltip-top"
                              data-tooltip="Add new question" (click)="onCreatePollQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                              Add new question
                            </a>
                          </div>
                        </section>
                      </div>
                    </div>
                    <div id="notes" class="content-tab row" style="display: none">

                      <div class="col">
                        <div class="row">
                          <div class="col-3">
                            <a class="button is-link is-small has-tooltip-top" *ngIf="
                                !domElementControl.showCreateNewNotesQuestion
                              " (click)="onCreateNotesQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                              Add your notes question
                            </a>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <ng-container *ngIf="domElementControl.showCreateNewNotesQuestion && is_notes_found">
                              <ng-container formArrayName="notes">
                                <div class="questionnarie row" *ngFor="
                                    let notesCtrl of notesQuestions().controls;
                                    let questIndex = index
                                  ">
                                  <div class="row" [formGroupName]="questIndex">
                                    <div class="col-11 mb-2">
                                      <angular-editor class="scroll-bar" id="question_{{ questIndex }}"
                                        formControlName="question" [config]="editorNotesConfig" cols="10"
                                        rows="5"></angular-editor>
                                    </div>
                                    <div class="col-1">
                                      <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                        data-tooltip="Remove Question" *ngIf="notesQuestions().length > 1"
                                        (click)="removeNotesQuestion(questIndex)">
                                        <i class="fa fa-times-circle mar-0-5"></i>
                                      </a>
                                    </div>
                                    <div class="col">
                                      <div *ngIf="
                                        (notesCtrl.get('question').touched ||
                                          notesCtrl.get('question').dirty) &&
                                        notesCtrl.get('question').invalid
                                      ">
                                        <div class="has-text-danger is-size-7" *ngIf="
                                          notesCtrl
                                            .get('question')
                                            .hasError('whitespace')
                                        ">
                                          Question is required
                                        </div>
                                      </div>
                                    </div>


                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                          </div>
                        </div>
                        <div class="row mb-2" *ngIf="notesQuestions().controls.length > 0">
                          <div class="col mt-2">
                            <a class="button  pull-right is-link is-small has-tooltip-top"
                              data-tooltip="Add new question" (click)="onCreateNotesQuestion()">
                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                              Add new notes question
                            </a>
                          </div>
                        </div>
                      </div>






                      <div class="field" style="display: none;">
                        <a class="button is-link is-outlined is-small has-tooltip-top" *ngIf="
                                !domElementControl.showCreateNewNotesQuestion
                              " (click)="onCreateNotesQuestion()">
                          <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                          Add your notes question
                        </a>
                      </div>
                      <section style="display: none;" class="section" *ngIf="
                              domElementControl.showCreateNewNotesQuestion &&
                              is_notes_found
                            ">
                        <div class="container" formArrayName="notes">
                          <div class="questionnarie" *ngFor="
                                  let notesCtrl of notesQuestions().controls;
                                  let questIndex = index
                                ">
                            <div class="" [formGroupName]="questIndex">
                              <!-- <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the notes question" formControlName="question"> -->
                              <angular-editor class="scroll-bar" id="question_{{ questIndex }}"
                                formControlName="question" [config]="editorNotesConfig" cols="10"
                                rows="5"></angular-editor>
                              <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                data-tooltip="Remove Question" *ngIf="notesQuestions().length > 1"
                                (click)="removeNotesQuestion(questIndex)">
                                <i class="fa fa-times-circle mar-0-5"></i>
                              </a>
                              <div *ngIf="
                                      (notesCtrl.get('question').touched ||
                                        notesCtrl.get('question').dirty) &&
                                      notesCtrl.get('question').invalid
                                    ">
                                <div class="has-text-danger is-size-6" *ngIf="
                                        notesCtrl
                                          .get('question')
                                          .hasError('whitespace')
                                      ">
                                  Question is required
                                </div>
                              </div>
                            </div>
                          </div>
                          <a class="button is-link is-outlined is-small has-tooltip-top" data-tooltip="Add new question"
                            (click)="onCreateNotesQuestion()">
                            <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                            Add new notes question
                          </a>
                        </div>
                      </section>
                    </div>


                  </div>
                </div>
              </div>

            </form>
          </div>
          <footer class="card-footer">
            <div class="columns is-fullwidth">
              <div class="column lessonPublish">
                <!-- <div class="field responsiveRadioBtn">
                  <input
                    id="switchPublish"
                    type="checkbox"
                    name="is_publish"
                    class="switch is-small is-success"
                    formControlName="is_publish"
                    [(ngModel)]="isPublish"
                  />
                  <label for="switchPublish">Publish this lesson?</label>
                </div> -->
              </div>
              <div class="column lessonSubmitBtn has-text-right">
                <div class="">
                  <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0"
                    (click)="
                      hideEditModal(upLoadedFileList, editedData['duration'])
                    ">
                    Cancel
                  </button>
                  <button type="button" class="actBtnDeskView button is-link is-small disabledBtn" [disabled]="
                      (editQuizForm.valid && !editQuizForm.dirty) ||
                      editQuizForm.invalid
                    " (click)="
                    updatePolicyFileData(
                        editQuizForm.value,
                        editedData['message_id']
                      )
                    " *ngIf="!showBtnSpinner">
                    Update
                  </button>
                  <button type="button" class="actBtnMobileView button is-link is-small disabledBtn" [disabled]="
                      (editQuizForm.valid && !editQuizForm.dirty) ||
                      editQuizForm.invalid
                    " (click)="
                    updatePolicyFileData(
                        editQuizForm.value,
                        editedData['message_id']
                      )
                    " *ngIf="!showBtnSpinner">
                    Update
                  </button>
                  <a class="button is-link is-loading is-small" style="min-width: 100px" *ngIf="showBtnSpinner"></a>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade policy-upload" [ngClass]="{'show':!viewControl.showHideEditFileUpload}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">

        <h5 class="modal-title">{{editedData?.message}}</h5>
        <span class="pull-right" (click)="hideEditModal(upLoadedFileList, editedData['duration'])"><i
            class="fa-solid fa-times"></i></span>
      </div>
      <div class="modal-body">
        <div class="library_tile_view">
          <div class="flex-container editedFileUpload">
            <div class="flex-item" style="width: 100%">
              <div class="card scroll-bar pos-relative" appInfiniteScroll infinite-scroll [scrollWindow]="true"
                [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle">
                <!-- <div class="card-header">
                  <p class="card-header-title">Edit lesson</p>
                </div> -->
                <div class="tabs mb-2 is-info is-outlined is-fullwidth is-small questionariesTab">
                  <ul>
                    <!-- <li class="is-active"><a>Interactive video</a></li> -->
                    <li class="tab" [ngClass]="{'is-active':seletedTab=='lesson'}" (click)="openTab($event, 'lesson')">
                      <a>Edit Policy</a>
                    </li>
                    <!-- <li class="tab" [ngClass]="{'is-active':seletedTab=='assessment'}"
                      (click)="openTab($event, 'assessment')">
                      <a>Assessment</a>
                    </li>
                    <li class="tab" [ngClass]="{'is-active':seletedTab=='survey'}" (click)="openTab($event, 'survey')">
                      <a>Survey</a>
                    </li>
                    <li class="tab" [ngClass]="{'is-active':seletedTab=='poll'}" (click)="openTab($event, 'poll')">
                      <a>Poll</a>
                    </li>
                    <li class="tab" [ngClass]="{'is-active':seletedTab=='notes'}" (click)="openTab($event, 'notes')">
                      <a>Notes</a>
                    </li> -->
                  </ul>
                </div>
                <div class="card-body mt-1 py-0">
                  <form [formGroup]="editQuizForm" novalidate>
                    <div class="pos-relative" infinite-scroll>
                      <div class="row">
                        <div class="col is-clearfix">
                          <!-- <div class="column is-5" style="display: none;">
                          <div class="field post-attach-file">
                           
                          <label class="label" *ngIf="uploadAttachFile">Attached File</label>
                            <div
                              class="control file is-fullwidth is-info-light"
                              *ngIf="!preUploadedFile && !uploadAttachFile"
                            >
                              <label class="file-label">
                                <input
                                  type="file"
                                  name="msg-file"
                                  style="display: none"
                                  #topicFileInput
                                  (change)="onFileChange($event)"
                                  accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .pptm, .xml, .xls, .xlsx, .doc, .docx, .txt"
                                />
                                <span class="file-cta">
                                  <span class="file-icon">
                                    <i class="fa fa-upload"></i>
                                  </span>
                                  <span class="file-label is-small is-centered">
                                    Upload a file…
                                  </span>
                                </span>
                              </label>
                            </div>
                          </div>
                          <div *ngIf="upLoadedFileList.length > 0">
                         
                            <div
                              class="pos-relative"
                              *ngFor="let eachFile of upLoadedFileList"
                            >
                              <div class="file-detail">
                                <div class="content-align">
                                  <p>
                                    <img
                                      src="../../../../assets/images/file_types/{{
                                        eachFile.mimeType
                                      }}.png"
                                      width="35px"
                                      height="35px"
                                    />
                                    {{ eachFile.name }}
                                  </p>
                                  <span class="file-size is-small">{{
                                    eachFile.size | fileSize
                                  }}</span>
                                  <progress
                                    class="progress is-link is-small"
                                    value="{{ eachFile.progressVal }}"
                                    max="100"
                                    *ngIf="eachFile.progressVal"
                                  ></progress>
                                </div>
                              </div>
                  
                            </div>
                          </div>
                          <div
                            class="is-small"
                            *ngIf="
                              preUploadedFile && uploadAttachFile;
                              else elseTemplate
                            "
                          >
                            <div *ngFor="let f of uploadFileIcons">
                              <span *ngIf="f.name === preUploadedFile.file_ext">
                                <img
                                  [src]="f.icons"
                                  alt=""
                                  width="35px"
                                  height="35px"
                                />{{ preUploadedFile.file_id }}
      
                                <button
                                  class="delete"
                                  aria-label="Delete"
                                  title="Remove upload file"
                                  (click)="
                                    removeUploadFile(
                                      upLoadedFileList,
                                      editedData['duration']
                                    )
                                  "
                                ></button>
                              </span>
                            </div>
                          </div>
                          <ng-template #elseTemplate>
                            <div
                              *ngIf="
                                uploadAttachFile && upLoadedFileList.length === 0
                              "
                            >
                              <span>
                                <p>
                                  <img
                                    src="../../../../assets/images/file_types/{{
                                      editedData['file_ext']
                                    }}.png"
                                    width="35px"
                                    height="35px"
                                  />
                                  {{ editedData["file_id"] }}
                                  <button
                                    class="delete"
                                    aria-label="Delete"
                                    title="Remove existing file"
                                    (click)="
                                      removeExitingFile(
                                        editedData['file_id'],
                                        editedData['duration']
                                      )
                                    "
                                  ></button>
                                </p>
                              </span>
                            </div>
                          </ng-template>
                          <div class="field">
                            <label class="label">Duration</label>
                            <div class="control">
                              <input
                                class="input"
                                type="text"
                                id="fileDuration"
                                name="duration"
                                placeholder="Video/Audio File Duration"
                                #durationInput
                                formControlName="duration"
                                [readonly]="true"
                              />
                            </div>
                          </div>
                          <div class="field responsiveRadioBtn">
                            <input
                              id="switchDownload"
                              type="checkbox"
                              name="is_download"
                              class="switch is-small is-success"
                              formControlName="is_download"
                              [(ngModel)]="isDownload"
                            />
                            <label for="switchDownload">Allow download?</label>
                          </div>
                             <div class="field responsiveRadioBtn">
                            <input
                              id="switchPublish"
                              type="checkbox"
                              name="is_publish"
                              class="switch is-small is-success"
                              formControlName="is_publish"
                              [(ngModel)]="isPublish"
                            />
                            <label for="switchPublish">Publish this lesson?</label>
                          </div>   
                          <div class="field">
                            <label class="label"
                              >Title
                              <span class="required">*</span>
                            </label>
                            <div class="control">
                              <input
                                class="input"
                                type="text"
                                name="title"
                                [(ngModel)]="editedData['message']"
                                placeholder="Title"
                                formControlName="message"
                              />
                            </div>
                          </div>
      
                          <div class="field">
                            <label class="label">Description</label>
                            <div class="control">
                              <angular-editor
                                class="scroll-bar"
                                [config]="editorConfig"
                                cols="10"
                                rows="2"
                                formControlName="description"
                              ></angular-editor>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column">
                              <div class="field">
                                <label class="label">Price $</label>
                                <div class="control">
                                  <input
                                    type="text"
                                    class="input"
                                    name="price"
                                    [(ngModel)]="editedData['price']"
                                    placeholder="Price $ 0.00"
                                    formControlName="price"
                                    (keypress)="numberOnlyValidator($event)"
                                    (keydown)="IsDecimalValue($event)"
                                  />
                                  <p
                                    class="is-small has-text-danger"
                                    *ngIf="priceValidate"
                                  >
                                    {{ priceErrMsg }}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="column">
                              <div class="field">
                                <label class="label">Discount %</label>
                                <div class="control">
                                  <input
                                    type="text"
                                    class="input"
                                    name="discount"
                                    [(ngModel)]="editedData['discount']"
                                    placeholder="Discount"
                                    formControlName="discount"
                                    (keypress)="isNumberKey($event)"
                                    maxlength="3"
                                    (keyup)="discountPercentage($event)"
                                  />
                                  <p
                                    class="is-small has-text-danger"
                                    *ngIf="discountValidate"
                                  >
                                    {{ priceErrMsg }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
      
                          <div class="field" style="display: none;">
                            <label class="label">Watermark Title</label>
                            <div class="control">
                              <input
                                type="text"
                                class="input"
                                name="watermark_title"
                                [(ngModel)]="editedData['water_mark_title']"
                                placeholder="Watermark Title"
                                formControlName="water_mark_title"
                              />
                            </div>
                          </div>
                        </div> -->
                          <ng-container [ngSwitch]="seletedTab">
                            <ng-container *ngSwitchCase="'lesson'">
                              <div id="lesson" class="content-tab row">
                                <div class="col-md-6">
                                  <div class="field post-attach-file">
                                    <!-- <video loop autoplay>
                                    <source [src]="inputSrc" type="video/mp4">
                                </video> -->
                                    <label class="label" *ngIf="uploadAttachFile">Attached File</label>
                                    <div class="control file is-fullwidth is-info-light"
                                      *ngIf="!preUploadedFile && !uploadAttachFile">
                                      <label class="file-label">
                                        <input type="file" name="msg-file" style="display: none" #topicFileInput
                                          (change)="onFileChange($event)"
                                          accept=".png, .jpeg, .jpg, .mp3, .mp4, .wav, .pdf, .ppt, .pptx, .pptm, .xml, .xls, .xlsx, .doc, .docx, .txt" />
                                        <span class="file-cta">
                                          <span class="file-icon">
                                            <i class="fa fa-upload"></i>
                                          </span>
                                          <span class="file-label is-small is-centered">
                                            Upload a file…
                                          </span>
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <div *ngIf="upLoadedFileList.length > 0">

                                    <div class="pos-relative" *ngFor="let eachFile of upLoadedFileList">
                                      <div class="file-detail">
                                        <div class="content-align">
                                          <p>
                                            <img src="../../../../assets/images/file_types/{{
                                              eachFile.mimeType
                                            }}.png" width="35px" height="35px" />
                                            {{ eachFile.name }}
                                          </p>
                                          <span class="file-size is-small">{{
                                            eachFile.size | fileSize
                                            }}</span>
                                          <progress class="progress is-link is-small" value="{{ eachFile.progressVal }}"
                                            max="100" *ngIf="eachFile.progressVal"></progress>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  <div class="is-small" *ngIf="
                                    preUploadedFile && uploadAttachFile;
                                    else elseTemplate
                                  ">
                                    <div *ngFor="let f of uploadFileIcons">
                                      <span *ngIf="f.name === preUploadedFile.file_ext">
                                        <img [src]="f.icons" alt="" width="35px" height="35px" />{{
                                        preUploadedFile.file_id }}

                                        <button class="delete" aria-label="Delete" title="Remove upload file" (click)="
                                          removeUploadFile(
                                            upLoadedFileList,
                                            editedData['duration']
                                          )
                                        "></button>
                                      </span>
                                    </div>
                                  </div>
                                  <ng-template #elseTemplate>
                                    <div *ngIf="
                                      uploadAttachFile && upLoadedFileList.length === 0
                                    ">
                                      <span>
                                        <p *ngIf="editedData['file_ext']">
                                          <img src="../../../../assets/images/file_types/{{
                                            editedData['file_ext']
                                          }}.png" width="35px" height="35px" />
                                          {{ editedData["file_id"] }}
                                          <button class="delete" aria-label="Delete" title="Remove existing file"
                                            (click)="
                                            removeExitingFile(
                                              editedData['file_id'],
                                              editedData['duration']
                                            )
                                          "></button>
                                        </p>
                                      </span>
                                    </div>
                                  </ng-template>
                                  <div class="field">
                                    <label class="label">Duration</label>
                                    <div class="control">
                                      <input class="input" type="text" id="fileDuration" name="duration"
                                        placeholder="Video/Audio File Duration" #durationInput
                                        formControlName="duration" [readonly]="true" />
                                    </div>
                                  </div>

                                  <!-- <div class="field responsiveRadioBtn">
                                  <input
                                    id="switchPublish"
                                    type="checkbox"
                                    name="is_publish"
                                    class="switch is-small is-success"
                                    formControlName="is_publish"
                                    [(ngModel)]="isPublish"
                                  />
                                  <label for="switchPublish">Publish this lesson?</label>
                                </div>   -->
                                  <div class="field">
                                    <label class="label">Title
                                      <span class="required">*</span>
                                    </label>
                                    <div class="control">
                                      <input class="input" type="text" name="title" [(ngModel)]="editedData['message']"
                                        placeholder="Title" formControlName="message" />
                                    </div>
                                  </div>
                                  <div class="field responsiveRadioBtn">
                                    <input id="switchDownload" type="checkbox" name="is_download"
                                      class="switch is-small is-success" formControlName="is_download"
                                      [(ngModel)]="isDownload" />
                                    <label for="switchDownload">Allow download?</label>
                                  </div>

                                  <div class="field" style="display: none;">
                                    <label class="label">Watermark Title</label>
                                    <div class="control">
                                      <input type="text" class="input" name="watermark_title"
                                        [(ngModel)]="editedData['water_mark_title']" placeholder="Watermark Title"
                                        formControlName="water_mark_title" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="field">
                                    <label class="label">Description</label>
                                    <div class="control">
                                      <angular-editor class="scroll-bar" [config]="editorConfig" cols="10" rows="2"
                                        formControlName="description"></angular-editor>
                                    </div>
                                  </div>


                                  <div class="field" style="display: none;">
                                    <label class="label">Price $</label>
                                    <div class="control">
                                      <input type="text" class="input" name="price" [(ngModel)]="editedData['price']"
                                        placeholder="Price $ 0.00" formControlName="price"
                                        (keypress)="numberOnlyValidator($event)" (keydown)="IsDecimalValue($event)" />
                                      <p class="is-small has-text-danger" *ngIf="priceValidate">
                                        {{ priceErrMsg }}
                                      </p>
                                    </div>
                                  </div>


                                  <div class="field" style="display: none;">
                                    <label class="label">Discount %</label>
                                    <div class="control">
                                      <input type="text" class="input" name="discount"
                                        [(ngModel)]="editedData['discount']" placeholder="Discount"
                                        formControlName="discount" (keypress)="isNumberKey($event)" maxlength="3"
                                        (keyup)="discountPercentage($event)" />
                                      <p class="is-small has-text-danger" *ngIf="discountValidate">
                                        {{ priceErrMsg }}
                                      </p>
                                    </div>
                                  </div>




                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'assessment'">
                              <div id="assessment" class="content-tab row">

                                <div class="col-12">
                                  <div class="row">
                                    <div class="col-12">
                                      <div class="row pull-right">
                                        <div class="col">
                                          <div class="field">
                                            <label class="label">Minimum % required</label>
                                            <div class="control">
                                              <input type="text" class="input" name="min_percentage" placeholder="%"
                                                formControlName="min_percentage" />
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col">
                                          <label class="label has-text-weight-bold">Allow to Re-Test?</label>
                                          <div class="field responsiveRadioBtn">
                                            <input id="switchReTest" type="checkbox" name="is_allow_retest"
                                              class="switch is-small is-success" formControlName="is_allow_retest"
                                              [(ngModel)]="isAllowRetest" />
                                            <label for="switchReTest"></label>
                                          </div>
                                        </div>
                                        <div class="col-auto">
                                          <div class="field">
                                            <label class="label">No.of Random Question
                                              <span class="required">*</span></label>
                                            <div class="control">
                                              <input type="text" class="input" name="random_question" placeholder=""
                                                formControlName="random_question" (keydown)="keyDownHandler($event)"
                                                (keypress)="numericOnlyHandler($event)" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-3">
                                      <a class="button is-link is-small has-tooltip-top mar-0-5"
                                        *ngIf="domElementControl.showCreateNewQuestions"
                                        data-tooltip="Add your first question" (click)="onCreateAssQuestion()">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add your assessment question
                                      </a>
                                    </div>
                                  </div>
                                  <div class="row">

                                    <!-- <ng-container formArrayName="assessment">
                                      <div class="questionnarie row"  *ngFor="
                                      let assessmentCtrl of assQuestion().controls;
                                      let questIndex = index">
                                      <div [formGroupName]="questIndex">
                                        <div class="col">
                                          <div class="row">
                                            <div class="question-choice col-md-3">
                                            <div class="field">
                                              <div class="label">
                                                <label class="label"
                                                  >Question Type
                                                  <span class="required"> *</span>
                                                </label>
                                                  <span class="control">
                                                    <div
                                                      class="radio"
                                                      *ngFor="
                                                        let item of questions;
                                                        let i = index
                                                      "
                                                    >
                                                      <input
                                                        [value]="item.value"
                                                        [id]="i"
                                                        formControlName="answer_type"
                                                        type="radio"
                                                        (click)="
                                                          onSelectedType(item, questIndex)
                                                        "
                                                      />
                                                      {{ item.viewValue }}
                                                    </div>
                                                  </span>
                                                 
                                             
                                              </div>
                                           
                                            </div>
                                            </div>
                                            <div class="field col-md-3 pull-left">
                                             <label class="label has-text-weight-bold">Mark &nbsp;<span class="required"> *</span></label> 
                                              <div class="control">
                                                <input
                                                  type="text"
                                                  class="input"
                                                  name="mark"
                                                  id="mark_{{ questIndex }}"
                                                  placeholder="Enter the mark"
                                                  formControlName="mark"
                                                  (keydown)="keyDownHandler($event)"
                                                  (keypress)="
                                                    numericOnlyHandler($event)
                                                  "
                                                />
                                                <div
                                                  *ngIf="
                                                    (assessmentCtrl.get('mark')
                                                      .touched ||
                                                      assessmentCtrl.get('mark')
                                                        .dirty) &&
                                                    assessmentCtrl.get('mark').invalid
                                                  "
                                                >
                                                  <div
                                                    class="has-text-danger is-size-7"
                                                    *ngIf="assessmentCtrl.get('mark').hasError('whitespace')"
                                                  >
                                                    Mark is required
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                         <div class="col">
                                          <label class="label has-text-weight-bold">Question</label>
                                         
                                         <div class="col">
                                          <input
                                          type="text"
                                          name="question"
                                          id="question_{{ questIndex }}"
                                          class="input"
                                          placeholder="Enter the question"
                                          formControlName="question"
                                          (keydown)="keyDownHandler($event)"
                                        />
                                        
                                        <a
                                        class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                        data-tooltip="Remove Question"
                               
                                        (click)="removeAssQuestion(questIndex)"
                                      >
                                        <i class="fa fa-times-circle mar-0-5"></i>
                                      </a> 
                                         </div> 
                                         <div class="col">
                                          <div
                                          *ngIf="
                                            (assessmentCtrl.get('question').touched ||
                                              assessmentCtrl.get('question').dirty) &&
                                            assessmentCtrl.get('question').invalid
                                          "
                                        >
                                          <div
                                            class="has-text-danger is-size-7"
                                            *ngIf="
                                              assessmentCtrl
                                                .get('question')
                                                .hasError('whitespace')
                                            "
                                          >
                                            Question is required
                                          </div>
                                        </div>
                                     
                                         </div>
                                  
                                         <div class="row">
                                          <div class="question-option col-10 pull-right mt-2  ms-2"
                                         formArrayName="answer"
                                         *ngIf="isShown[questIndex]"
                                       >
                                       <label class="label has-text-weight-bold">Answers</label>
                                       <div
                                       class="control"
                                       *ngFor="
                                         let answerCtrl of assQuestAnswers(
                                           questIndex
                                         ).controls;
                                         let optionIndex = index
                                       ">
                                      
                                       <div
                                         class=""
                                         [formGroupName]="optionIndex"
                                       >
                                         <input
                                           type="text"
                                           name="answer"
                                           class="input"
                                           id="answer_{{ optionIndex }}"
                                           placeholder="Enter the answer"
                                           formControlName="answer"
                                         />
                                         <input
                                           type="hidden"
                                           name="answer_id"
                                           class="input"
                                           id="answer_id_{{ optionIndex }}"
                                           placeholder="Enter the answer"
                                           formControlName="answer_id"
                                         />
                                         <input
                                           type="radio"
                                           class="is-checkradio"
                                           [ngClass]="{
                                             'is-danger':
                                               selectedOptions[questIndex]
                                           }"
                                           name="is_correct_answer{{
                                             questIndex
                                           }}"
                                           id="correctAnswer_{{
                                             questIndex
                                           }}-{{ optionIndex }}"
                                           [checked]="answerCtrl.value.is_correct_answer"
                                           value="{{ isChecked }}"
                                           (click)="
                                             onCheckedAnswer(
                                               $event,
                                               assessmentCtrl,
                                               questIndex,
                                               optionIndex
                                             )
                                           "
                                         />
                                         <label
                                           for="correctAnswer_{{
                                             questIndex
                                           }}-{{ optionIndex }}"
                                           title="Check correct answer"
                                         ></label>
                                         <a
                                           class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                           data-tooltip="Remove Answer"
                                           *ngIf="
                                             assQuestAnswers(questIndex)
                                               .controls.length > 1
                                           "
                                           (click)="
                                             removeAssOptions(
                                               questIndex,
                                               optionIndex,
                                               answerCtrl
                                             )
                                           "
                                         >
                                           <i
                                             class="fa fa-times-circle"
                                             aria-hidden="true"
                                           ></i>
                                         </a>
                                         <div
                                           *ngIf="
                                             (answerCtrl.get('answer')
                                               .touched ||
                                               answerCtrl.get('answer')
                                                 .dirty) &&
                                             answerCtrl.get('answer').invalid
                                           "
                                         >
                                           <div
                                             class="has-text-danger is-size-6"
                                             *ngIf="
                                               answerCtrl
                                                 .get('answer')
                                                 .hasError('whitespace')
                                             "
                                           >
                                             Answer is required
                                           </div>
                                         </div>
                                       </div>
                                     </div>
                                         <a
                                           class="button is-link is-outlined is-small has-tooltip-top mt-1"
                                           data-tooltip="Add more choice"
                                           (click)="onCreateAssOption(questIndex)"
                                         >
                                           <i
                                             class=" fa-solid fa-circle-plus mar-0-5"
                                             aria-hidden="true"
                                           ></i>
                                           Add more choice
                                         </a>
                                          </div>
                                          <p
                                          class="has-text-danger is-small is-size-7"
                                          *ngIf="selectedOptions[questIndex]"
                                        >
                                          Please select any one answer
                                          </p>
                                         </div>   
                                         <div class="col mt-2 pull-right">
                                          <button
                                          class="button is-link is-outlined is-small has-tooltip-top"
                                          (click)="onCreateAssQuestion()"
                                        >
                                          <i
                                            class=" fa-solid fa-circle-plus mar-0-5"
                                            aria-hidden="true"
                                          ></i>
                                          Add new question
                                        </button>
                                        </div>
                                         
                                        </div>
                                      </div>
                                      </div>
                                    </ng-container> -->
                                  </div>

                                </div>


                                <div class="col-12">
                                  <div class="row">
                                    <div class="col-3">
                                      <a class="button is-link is-small has-tooltip-top mar-0-5"
                                        *ngIf="!domElementControl.showCreateNewQuestions"
                                        data-tooltip="Add your first question" (click)="onCreateAssQuestion()">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add your assessment question
                                      </a>
                                    </div>
                                  </div>
                                  <div class="row" *ngIf="
                                      domElementControl.showCreateNewQuestions &&
                                      is_question_found
                                    ">


                                    <div class="row">

                                      <ng-container formArrayName="assessment">
                                        <div class="questionnarie row" *ngFor="
                                            let assessmentCtrl of assQuestion()
                                              .controls;
                                            let questIndex = index
                                          ">
                                          <div [formGroupName]="questIndex">
                                            <div class="col">
                                              <div class="row">
                                                <div class="question-choice col-md-3">
                                                  <label class="form-label"><b>Question Type</b>
                                                    <span class="required"> *</span>
                                                    &nbsp;&nbsp;
                                                  </label>
                                                  <br>
                                                  <span class="radio" *ngFor="
                                                  let item of questions;
                                                  let i = index
                                                ">
                                                    <input [value]="item.value" [id]="i" formControlName="answer_type"
                                                      type="radio" (click)="
                                                    onSelectedType(
                                                      item,
                                                      questIndex
                                                    )
                                                  " />
                                                    {{ item.viewValue }}
                                                  </span>
                                                </div>
                                                <div class="field col-md-3 pull-left">
                                                  <label class="label">Mark</label>
                                                  <div class="field">
                                                    <div class="control">
                                                      <input type="text" class="input" [ngClass]="{
                                                          'is-danger':
                                                            markOptions[questIndex]
                                                        }" name="mark" id="mark_{{ questIndex }}"
                                                        placeholder="Enter the mark" formControlName="mark" (keypress)="
                                                          numericOnlyHandler($event)
                                                        " />
                                                      <div *ngIf="
                                                          (assessmentCtrl.get('mark')
                                                            .touched ||
                                                            assessmentCtrl.get('mark')
                                                              .dirty) &&
                                                          assessmentCtrl.get('mark')
                                                            .invalid
                                                        ">
                                                        <div class="has-text-danger is-size-6" *ngIf="
                                                            assessmentCtrl
                                                              .get('mark')
                                                              .hasError('whitespace')
                                                          ">
                                                          Mark is required
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div class="row align-items-center">
                                              <label class="label has-text-weight-bold">Question</label>
                                              <div class="col-12">
                                                <span class="col-9 pull-left">
                                                  <input type="text" name="question" id="question_{{ questIndex }}"
                                                    class="input" placeholder="Enter the question"
                                                    formControlName="question" />
                                                  <input type="hidden" name="question_id"
                                                    id="question_id_{{ questIndex }}" class="input"
                                                    placeholder="Enter the question" formControlName="question_id" />
                                                </span>
                                                <span class="pull-left ms-2">
                                                  <a class="icon has-text-grey-lighter has-tooltip-left"
                                                    data-tooltip="Remove Question" *ngIf="assQuestion().length > 0"
                                                    (click)="removeAssQuestion(questIndex)">
                                                    <i class="fa fa-times-circle mar-0-5"></i>
                                                  </a>
                                                </span>
                                              </div>


                                            </div>
                                            <div *ngIf="
                                                (assessmentCtrl.get('question')
                                                  .touched ||
                                                  assessmentCtrl.get('question')
                                                    .dirty) &&
                                                assessmentCtrl.get('question').invalid
                                              ">
                                              <div class="has-text-danger is-size-6" *ngIf="
                                                  assessmentCtrl
                                                    .get('question')
                                                    .hasError('whitespace')
                                                ">
                                                Question is required
                                              </div>
                                            </div>



                                            <div class="question-option" [ngClass]="{
                                                questionOption:
                                                  removeAnsClass[questIndex]
                                              }" formArrayName="answer">
                                              <label class="label has-text-weight-bold">Answers</label>
                                              <div class="control" *ngFor="
                                                  let answerCtrl of assQuestAnswers(
                                                    questIndex
                                                  ).controls;
                                                  let optionIndex = index
                                                ">
                                                <div class="" [formGroupName]="optionIndex">
                                                  <input type="text" name="answer" class="input"
                                                    id="answer_{{ optionIndex }}" placeholder="Enter the answer"
                                                    formControlName="answer" />
                                                  <input type="hidden" name="answer_id" class="input"
                                                    id="answer_id_{{ optionIndex }}" placeholder="Enter the answer"
                                                    formControlName="answer_id" />
                                                  <input type="radio" class="is-checkradio" [ngClass]="{
                                                      'is-danger':
                                                        selectedOptions[questIndex]
                                                    }" name="is_correct_answer{{
                                                      questIndex
                                                    }}" id="correctAnswer_{{
                                                      questIndex
                                                    }}-{{ optionIndex }}" [checked]="
                                                      answerCtrl.value.is_correct_answer
                                                    " value="{{ isChecked }}" (click)="
                                                      onCheckedAnswer(
                                                        $event,
                                                        assessmentCtrl,
                                                        questIndex,
                                                        optionIndex
                                                      )
                                                    " />
                                                  <label for="correctAnswer_{{
                                                      questIndex
                                                    }}-{{ optionIndex }}" title="Check correct answer"></label>
                                                  <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                                    data-tooltip="Remove Answer" *ngIf="
                                                      assQuestAnswers(questIndex)
                                                        .controls.length > 1
                                                    " (click)="
                                                      removeAssOptions(
                                                        questIndex,
                                                        optionIndex,
                                                        answerCtrl
                                                      )
                                                    ">
                                                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                  </a>
                                                  <div *ngIf="
                                                      (answerCtrl.get('answer')
                                                        .touched ||
                                                        answerCtrl.get('answer')
                                                          .dirty) &&
                                                      answerCtrl.get('answer').invalid
                                                    ">
                                                    <div class="has-text-danger is-size-6" *ngIf="
                                                        answerCtrl
                                                          .get('answer')
                                                          .hasError('whitespace')
                                                      ">
                                                      Answer is required
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <a *ngIf="isShown[questIndex]"
                                                class="button is-link  is-small mb-2 has-tooltip-top"
                                                data-tooltip="Add more choice" (click)="onCreateAssOption(questIndex)">
                                                <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                                Add more choice
                                              </a>
                                            </div>

                                          </div>
                                          <p class="has-text-danger is-small is-size-6"
                                            *ngIf="selectedOptions[questIndex]">
                                            Please select any one answer
                                          </p>
                                        </div>
                                        <div class="col mt-2 mb-2">
                                          <button class="button pull-right is-link  is-small has-tooltip-top"
                                            (click)="onCreateAssQuestion()">
                                            <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                            Add new question
                                          </button>
                                        </div>
                                        <!-- <a
                                          class="button is-link is-outlined is-small has-tooltip-top"
                                          data-tooltip="Add new question"
                                          (click)="onCreateAssQuestion()"
                                        >
                                          <i
                                            class=" fa-solid fa-circle-plus mar-0-5"
                                            aria-hidden="true"
                                          ></i>
                                          Add new question
                                        </a> -->
                                      </ng-container>
                                    </div>

                                  </div>
                                </div>


                              </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'survey'">
                              <div id="survey" class="content-tab row">

                                <div class="col">
                                  <div class="row">
                                    <div class="col-3">
                                      <a class="button is-link is-small has-tooltip-top"
                                        *ngIf="!domElementControl.showCreateNewSurQuestion"
                                        (click)="onCreateSurveyQuestion()">
                                        <i class="fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add your survey question
                                      </a>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <ng-container *ngIf="domElementControl.showCreateNewSurQuestion && is_survey_found">
                                      <ng-container formArrayName="survey">
                                        <div class="questionnarie row"
                                          *ngFor="let surveyCtrl of surveyQuestions().controls; let questIndex = index">
                                          <div [formGroupName]="questIndex">
                                            <div class="col">
                                              <label class="label has-text-weight-bold">Question</label>
                                              <div class="col">
                                                <input type="text" name="question" id="question_{{ questIndex }}"
                                                  class="input" placeholder="Enter the question"
                                                  formControlName="question" />
                                                <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                                  data-tooltip="Remove Question" *ngIf="
                                                  surveyQuestions().controls.length > 0
                                                " (click)="
                                                  onRemoveSurveyQuestion(questIndex)
                                                ">
                                                  <i class="fa fa-times-circle mar-0-5"></i>
                                                </a>
                                              </div>
                                              <div class="col">
                                                <div *ngIf="
                                                  (surveyCtrl.get('question').touched ||
                                                    surveyCtrl.get('question').dirty) &&
                                                  surveyCtrl.get('question').invalid
                                                ">
                                                  <div class="has-text-danger is-size-6" *ngIf="
                                                    surveyCtrl
                                                      .get('question')
                                                      .hasError('whitespace')
                                                  ">
                                                    Question is required
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col mt-2">
                                              <label class="label has-text-weight-bold">Answers</label>
                                              <div class="row">
                                                <div class="question-option col-10 pull-right ms-2"
                                                  formArrayName="answer">
                                                  <div class="control  mb-2" *ngFor="
                                                    let answerCtrl of surveyOptions(
                                                      questIndex
                                                    ).controls;
                                                    let optionIndex = index
                                                  ">
                                                    <div class="" [formGroupName]="optionIndex">
                                                      <input type="text" name="answer" class="input"
                                                        id="answer_{{ optionIndex }}" placeholder="Enter the answer"
                                                        formControlName="answer" />
                                                      <label for="correctAnswer_{{
                                                        questIndex
                                                      }}-{{ optionIndex }}" title="Check correct answer"></label>
                                                      <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                                        data-tooltip="Remove Answer" *ngIf="
                                                        surveyOptions(questIndex).controls
                                                          .length > 1
                                                      " (click)="
                                                        removeSurveyOptions(
                                                          questIndex,
                                                          optionIndex
                                                        )
                                                      ">
                                                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                      </a>
                                                      <div *ngIf="
                                                        (answerCtrl.get('answer')
                                                          .touched ||
                                                          answerCtrl.get('answer')
                                                            .dirty) &&
                                                        answerCtrl.get('answer').invalid
                                                      ">
                                                        <div class="has-text-danger is-size-6" *ngIf="
                                                          answerCtrl
                                                            .get('answer')
                                                            .hasError('whitespace')
                                                        ">
                                                          Answer is required
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <a class="button is-link is-small has-tooltip-top"
                                                    data-tooltip="Add more choice"
                                                    (click)="oncreateSurveyOptions(questIndex)">
                                                    <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                                    Add more choice
                                                  </a>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col mt-2 mb-2 pull-right">
                                              <a class="button is-link is-small has-tooltip-top"
                                                data-tooltip="Add new question" (click)="onCreateSurveyQuestion()">
                                                <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                                Add new question
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </ng-container>
                                    </ng-container>
                                  </div>
                                </div>
                                <div class="field" style="display: none;">

                                  <section class="section"
                                    *ngIf="domElementControl.showCreateNewSurQuestion && is_survey_found">
                                    <div class="container" formArrayName="survey">
                                      <div class="questionnarie" *ngFor="
                                          let surveyCtrl of surveyQuestions()
                                            .controls;
                                          let questIndex = index
                                        ">
                                        <div class="" [formGroupName]="questIndex">
                                          <input type="text" name="question" id="question_{{ questIndex }}"
                                            class="input" placeholder="Enter the question" formControlName="question" />
                                          <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                            data-tooltip="Remove Question" *ngIf="
                                              surveyQuestions().controls.length > 0
                                            " (click)="
                                              onRemoveSurveyQuestion(questIndex)
                                            ">
                                            <i class="fa fa-times-circle mar-0-5"></i>
                                          </a>
                                          <div *ngIf="
                                              (surveyCtrl.get('question').touched ||
                                                surveyCtrl.get('question').dirty) &&
                                              surveyCtrl.get('question').invalid
                                            ">
                                            <div class="has-text-danger is-size-6" *ngIf="
                                                surveyCtrl
                                                  .get('question')
                                                  .hasError('whitespace')
                                              ">
                                              Question is required
                                            </div>
                                          </div>
                                          <div class="question-option" formArrayName="answer">
                                            <div class="control" *ngFor="
                                                let answerCtrl of surveyOptions(
                                                  questIndex
                                                ).controls;
                                                let optionIndex = index
                                              ">
                                              <div class="" [formGroupName]="optionIndex">
                                                <input type="text" name="answer" class="input"
                                                  id="answer_{{ optionIndex }}" placeholder="Enter the answer"
                                                  formControlName="answer" />
                                                <label for="correctAnswer_{{
                                                    questIndex
                                                  }}-{{ optionIndex }}" title="Check correct answer"></label>
                                                <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                                  data-tooltip="Remove Answer" *ngIf="
                                                    surveyOptions(questIndex).controls
                                                      .length > 1
                                                  " (click)="
                                                    removeSurveyOptions(
                                                      questIndex,
                                                      optionIndex
                                                    )
                                                  ">
                                                  <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                </a>
                                                <div *ngIf="
                                                    (answerCtrl.get('answer')
                                                      .touched ||
                                                      answerCtrl.get('answer')
                                                        .dirty) &&
                                                    answerCtrl.get('answer').invalid
                                                  ">
                                                  <div class="has-text-danger is-size-6" *ngIf="
                                                      answerCtrl
                                                        .get('answer')
                                                        .hasError('whitespace')
                                                    ">
                                                    Answer is required
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <a class="button is-link is-outlined is-small has-tooltip-top"
                                              data-tooltip="Add more choice" (click)="
                                                oncreateSurveyOptions(questIndex)
                                              ">
                                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                              Add more choice
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                      <a class="button is-link is-outlined is-small has-tooltip-top"
                                        data-tooltip="Add new question" (click)="onCreateSurveyQuestion()">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add new question
                                      </a>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'poll'">
                              <div id="poll" class="content-tab row">

                                <div class="col">
                                  <div class="row">
                                    <div class="col-3">
                                      <a class="button is-link is-small has-tooltip-top mar-0-5" *ngIf="
                                        !domElementControl.showCreateNewPolQuestion
                                      " data-tooltip="Add your first question" (click)="onCreatePollQuestion()">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add your poll question
                                      </a>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <ng-container *ngIf="domElementControl.showCreateNewPolQuestion &&
                                     is_polls_found">
                                      <ng-container formArrayName="polls">
                                        <div class="questionnarie row" *ngFor="
                                        let pollCtrl of pollQuestions().controls;
                                        let questIndex = index
                                      ">
                                          <div [formGroupName]="questIndex">
                                            <div class="col">
                                              <label class="label has-text-weight-bold">Question</label>
                                              <div class="col">
                                                <input type="text" name="question" id="question_{{ questIndex }}"
                                                  class="input" placeholder="Enter the question"
                                                  formControlName="question" />
                                                <input type="hidden" name="question_id"
                                                  id="question_id_{{ questIndex }}" class="input"
                                                  placeholder="Enter the question" formControlName="question_id" />
                                                <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                                  data-tooltip="Remove Question" *ngIf="
                                              pollQuestions().controls.length > 0
                                            " (click)="removePollQuestion(questIndex)">
                                                  <i class="fa fa-times-circle mar-0-5"></i>
                                                </a>
                                              </div>
                                              <div class="col">
                                                <div *ngIf="
                                              (pollCtrl.get('question').touched ||
                                                pollCtrl.get('question').dirty) &&
                                              pollCtrl.get('question').invalid
                                            ">
                                                  <div class="has-text-danger is-size-7" *ngIf="
                                                pollCtrl
                                                  .get('question')
                                                  .hasError('whitespace')
                                              ">
                                                    Question is required
                                                  </div>
                                                </div>
                                              </div>

                                              <div class="col mt-2 ">
                                                <label class="label has-text-weight-bold">Answers</label>
                                                <div class="row">
                                                  <div class="question-option col-10 pull-right  ms-2"
                                                    formArrayName="answer">
                                                    <div class="control mb-2" *ngFor="
                                                  let answerCtrl of pollOptions(
                                                    questIndex
                                                  ).controls;
                                                  let optionIndex = index
                                                ">
                                                      <div class="" [formGroupName]="optionIndex">
                                                        <input type="text" name="answer" class="input"
                                                          id="answer_{{ optionIndex }}" placeholder="Enter the answer"
                                                          formControlName="answer" />
                                                        <input type="hidden" name="answer_id" class="input"
                                                          id="answer_id_{{ optionIndex }}"
                                                          placeholder="Enter the answer" formControlName="answer_id" />
                                                        <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                                          data-tooltip="Remove Answer" *ngIf="
                                                      pollOptions(questIndex).controls
                                                        .length > 1
                                                    " (click)="
                                                      onRemovePollOptions(
                                                        questIndex,
                                                        optionIndex,
                                                        answerCtrl
                                                      )
                                                    ">
                                                          <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                        </a>
                                                        <div *ngIf="
                                                      (answerCtrl.get('answer')
                                                        .touched ||
                                                        answerCtrl.get('answer')
                                                          .dirty) &&
                                                      answerCtrl.get('answer').invalid
                                                    ">
                                                          <div class="has-text-danger is-size-7" *ngIf="
                                                        answerCtrl
                                                          .get('answer')
                                                          .hasError('whitespace')
                                                      ">
                                                            Answer is required
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <a class="button is-link  is-small has-tooltip-top"
                                                      data-tooltip="Add more choice" (click)="
                                                  onCreatePollOptions(questIndex)
                                                ">
                                                      <i class=" fa-solid fa-circle-plus mar-0-5"
                                                        aria-hidden="true"></i>
                                                      Add more choice
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col mt-2 mb-2 pull-right">
                                                <a class="button is-link is-small has-tooltip-top"
                                                  data-tooltip="Add new question" (click)="onCreatePollQuestion()">
                                                  <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                                  Add new question
                                                </a>
                                              </div>
                                            </div>








                                          </div>
                                        </div>
                                      </ng-container>
                                    </ng-container>
                                  </div>
                                </div>


                                <div class="field" style="display: none;">
                                  <a class="button is-link is-outlined is-small has-tooltip-top mar-0-5" *ngIf="
                                      !domElementControl.showCreateNewPolQuestion
                                    " data-tooltip="Add your first question" (click)="onCreatePollQuestion()">
                                    <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                    Add your poll question
                                  </a>
                                  <section class="section" *ngIf="
                                      domElementControl.showCreateNewPolQuestion &&
                                      is_polls_found
                                    ">
                                    <div class="container" formArrayName="polls">
                                      <div class="questionnarie" *ngFor="
                                          let pollCtrl of pollQuestions().controls;
                                          let questIndex = index
                                        ">
                                        <div class="" [formGroupName]="questIndex">
                                          <input type="text" name="question" id="question_{{ questIndex }}"
                                            class="input" placeholder="Enter the question" formControlName="question" />
                                          <input type="hidden" name="question_id" id="question_id_{{ questIndex }}"
                                            class="input" placeholder="Enter the question"
                                            formControlName="question_id" />
                                          <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                            data-tooltip="Remove Question" *ngIf="
                                              pollQuestions().controls.length > 0
                                            " (click)="removePollQuestion(questIndex)">
                                            <i class="fa fa-times-circle mar-0-5"></i>
                                          </a>
                                          <div *ngIf="
                                              (pollCtrl.get('question').touched ||
                                                pollCtrl.get('question').dirty) &&
                                              pollCtrl.get('question').invalid
                                            ">
                                            <div class="has-text-danger is-size-6" *ngIf="
                                                pollCtrl
                                                  .get('question')
                                                  .hasError('whitespace')
                                              ">
                                              Question is required
                                            </div>
                                          </div>
                                          <div class="question-option" formArrayName="answer">
                                            <div class="control" *ngFor="
                                                let answerCtrl of pollOptions(
                                                  questIndex
                                                ).controls;
                                                let optionIndex = index
                                              ">
                                              <div class="" [formGroupName]="optionIndex">
                                                <input type="text" name="answer" class="input"
                                                  id="answer_{{ optionIndex }}" placeholder="Enter the answer"
                                                  formControlName="answer" />
                                                <input type="hidden" name="answer_id" class="input"
                                                  id="answer_id_{{ optionIndex }}" placeholder="Enter the answer"
                                                  formControlName="answer_id" />
                                                <a class="icon has-text-grey-lighter has-tooltip-left removeOptions"
                                                  data-tooltip="Remove Answer" *ngIf="
                                                    pollOptions(questIndex).controls
                                                      .length > 1
                                                  " (click)="
                                                    onRemovePollOptions(
                                                      questIndex,
                                                      optionIndex,
                                                      answerCtrl
                                                    )
                                                  ">
                                                  <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                </a>
                                                <div *ngIf="
                                                    (answerCtrl.get('answer')
                                                      .touched ||
                                                      answerCtrl.get('answer')
                                                        .dirty) &&
                                                    answerCtrl.get('answer').invalid
                                                  ">
                                                  <div class="has-text-danger is-size-6" *ngIf="
                                                      answerCtrl
                                                        .get('answer')
                                                        .hasError('whitespace')
                                                    ">
                                                    Answer is required
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <a class="button is-link is-outlined is-small has-tooltip-top"
                                              data-tooltip="Add more choice" (click)="
                                                onCreatePollOptions(questIndex)
                                              ">
                                              <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                              Add more choice
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                      <a class="button is-link is-outlined is-small has-tooltip-top"
                                        data-tooltip="Add new question" (click)="onCreatePollQuestion()">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add new question
                                      </a>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'notes'">
                              <div id="notes" class="content-tab row">

                                <div class="col">
                                  <div class="row">
                                    <div class="col-3">
                                      <a class="button is-link is-small has-tooltip-top" *ngIf="
                                      !domElementControl.showCreateNewNotesQuestion
                                    " (click)="onCreateNotesQuestion()">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add your notes question
                                      </a>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col">
                                      <ng-container
                                        *ngIf="domElementControl.showCreateNewNotesQuestion && is_notes_found">
                                        <ng-container formArrayName="notes">
                                          <div class="questionnarie row" *ngFor="
                                          let notesCtrl of notesQuestions().controls;
                                          let questIndex = index
                                        ">
                                            <div class="row" [formGroupName]="questIndex">
                                              <div class="col-11 mb-2">
                                                <angular-editor class="scroll-bar" id="question_{{ questIndex }}"
                                                  formControlName="question" [config]="editorNotesConfig" cols="10"
                                                  rows="5"></angular-editor>
                                              </div>
                                              <div class="col-1">
                                                <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                                  data-tooltip="Remove Question" *ngIf="notesQuestions().length > 1"
                                                  (click)="removeNotesQuestion(questIndex)">
                                                  <i class="fa fa-times-circle mar-0-5"></i>
                                                </a>
                                              </div>
                                              <div class="col">
                                                <div *ngIf="
                                              (notesCtrl.get('question').touched ||
                                                notesCtrl.get('question').dirty) &&
                                              notesCtrl.get('question').invalid
                                            ">
                                                  <div class="has-text-danger is-size-7" *ngIf="
                                                notesCtrl
                                                  .get('question')
                                                  .hasError('whitespace')
                                              ">
                                                    Question is required
                                                  </div>
                                                </div>
                                              </div>


                                            </div>
                                          </div>
                                        </ng-container>
                                      </ng-container>
                                    </div>
                                  </div>
                                  <div class="row mb-2" *ngIf="notesQuestions().controls.length > 0">
                                    <div class="col mt-2">
                                      <a class="button  pull-right is-link is-small has-tooltip-top"
                                        data-tooltip="Add new question" (click)="onCreateNotesQuestion()">
                                        <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                        Add new notes question
                                      </a>
                                    </div>
                                  </div>
                                </div>






                                <div class="field" style="display: none;">
                                  <a class="button is-link is-outlined is-small has-tooltip-top" *ngIf="
                                      !domElementControl.showCreateNewNotesQuestion
                                    " (click)="onCreateNotesQuestion()">
                                    <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                    Add your notes question
                                  </a>
                                </div>
                                <section style="display: none;" class="section" *ngIf="
                                    domElementControl.showCreateNewNotesQuestion &&
                                    is_notes_found
                                  ">
                                  <div class="container" formArrayName="notes">
                                    <div class="questionnarie" *ngFor="
                                        let notesCtrl of notesQuestions().controls;
                                        let questIndex = index
                                      ">
                                      <div class="" [formGroupName]="questIndex">
                                        <!-- <input type="text" name="question" id="question_{{questIndex}}" class="input" placeholder="Enter the notes question" formControlName="question"> -->
                                        <angular-editor class="scroll-bar" id="question_{{ questIndex }}"
                                          formControlName="question" [config]="editorNotesConfig" cols="10"
                                          rows="5"></angular-editor>
                                        <a class="icon removeAssQuestion has-text-grey-lighter has-tooltip-left"
                                          data-tooltip="Remove Question" *ngIf="notesQuestions().length > 1"
                                          (click)="removeNotesQuestion(questIndex)">
                                          <i class="fa fa-times-circle mar-0-5"></i>
                                        </a>
                                        <div *ngIf="
                                            (notesCtrl.get('question').touched ||
                                              notesCtrl.get('question').dirty) &&
                                            notesCtrl.get('question').invalid
                                          ">
                                          <div class="has-text-danger is-size-6" *ngIf="
                                              notesCtrl
                                                .get('question')
                                                .hasError('whitespace')
                                            ">
                                            Question is required
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <a class="button is-link is-outlined is-small has-tooltip-top"
                                      data-tooltip="Add new question" (click)="onCreateNotesQuestion()">
                                      <i class=" fa-solid fa-circle-plus mar-0-5" aria-hidden="true"></i>
                                      Add new notes question
                                    </a>
                                  </div>
                                </section>
                              </div>
                            </ng-container>
                          </ng-container>

                        </div>
                      </div>
                    </div>

                  </form>
                </div>
                <footer class="card-footer">
                  <div class="columns is-fullwidth">
                    <div class="column lessonPublish">
                      <!-- <div class="field responsiveRadioBtn">
                        <input
                          id="switchPublish"
                          type="checkbox"
                          name="is_publish"
                          class="switch is-small is-success"
                          formControlName="is_publish"
                          [(ngModel)]="isPublish"
                        />
                        <label for="switchPublish">Publish this lesson?</label>
                      </div> -->
                    </div>
                    <div class="column lessonSubmitBtn has-text-right">
                      <div class="">
                        <button type="button" class="button mar-0-5 is-small" [disabled]="upLoadedFileList.length > 0"
                          (click)="
                            hideEditModal(upLoadedFileList, editedData['duration'])
                          ">
                          Cancel
                        </button>
                        <button type="button" class="button is-link is-small disabledBtn" [disabled]="
                            (editQuizForm.valid && !editQuizForm.dirty) ||
                            editQuizForm.invalid
                          " (click)="
                          updatePolicyFileData(
                              editQuizForm.value,
                              editedData['message_id']
                            )
                          " *ngIf="!showBtnSpinner">
                          Update
                        </button>

                        <a class="button is-link is-loading is-small" style="min-width: 100px"
                          *ngIf="showBtnSpinner"></a>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="empty-state">
  <div class="common-empty topic-notify" *ngIf="this.classFileList.length == 0">
    <article class="media">
      <div class="media-content has-text-centered">

        <!-- <img [src]="'../../../../assets/images/notification_empty.svg'" /> -->
        <p>No records Found</p>
        <!-- <span class="has-text-grey-light"
        *ngIf="isUserRole === 1">Start adding Policy and share it with your user.</span
        > -->
      </div>
    </article>
    <!-- <div class="has-text-centered">
      <a class="button is-link is-small">

        <span> Create a Lesson</span>
      </a>
    </div> -->
  </div>
</div>

<div class="showAssignment">
  <!--Assessment Test View-->
  <div class="modal" [ngClass]="{ 'is-active': showHiddenAssessmentModal[mesgIds] }">
    <div class="modal-background"></div>
    <div class="modal-card" style="padding:20px;">
      <div class="card" *ngIf="isUserRole != 1 && viewControl.showAssessmentMarks">
        <form [formGroup]="assessmentForm" class="assQuestTest">
          <div class="card-header">
            <p class="card-header-title">Assessment Test</p>
            <span class="card-header-title is-size-6 has-text-right"
              style="font-weight: normal; position: absolute; right: 0">No.of Questions: {{ pager.count }}</span>
            <button class="delete" aria-label="close" *ngIf="isUserRole === 1"
              (click)="hideModalAssessment(mesgIds)"></button>
          </div>
          <div class="card-content scroll-bar pos-relative" appInfiniteScroll infinite-scroll
            [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
            [scrollWindow]="false">
            <div class="content">
              <div class="notification is-danger is-light" *ngIf="assetFormValid">
                <button class="delete"></button>
                Must check some option!
              </div>
              <div class="question">
                <div *ngFor="let data of getAssessmentData; let i = index" style="padding-bottom: 10px">
                  <div *ngIf="data.question_type === 'question'">
                    <h3 class="is-medium label is-size-6">
                      Q{{ i + 1 }}.
                      <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                    </h3>
                    <div *ngIf="data.answer_type === 'choice'; else elseTemplate">
                      <div class="options surveyquiz">
                        <div class="" *ngFor="let option of data.answer; let i = index">
                          <div class="option has-text-grey-light">
                            <div class="field">
                              <input class="is-checkradio" id="{{ data.question_id }}-{{
                                  option.answer_id
                                }}" type="radio" name="{{ data.question_id }}-answers" value="{{ option.answer_id }}"
                                (change)="
                                  onSelectedAssRadio(
                                    data,
                                    option,
                                    assessmentForm.value
                                  )
                                " />
                              <label class="is-size-6" style="font-size: 15px !important" for="{{ data.question_id }}-{{
                                  option.answer_id
                                }}">{{ option.answer }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #elseTemplate>
                      <textarea name="user_answer" class="textarea" id="" cols="30" rows="5"
                        placeholder="Enter the short answer here..." formControlName="user_answer" (change)="
                          onSelectedAssRadio(data, option, assessmentForm.value)
                        "></textarea>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div class="has-text-right footer-elibrary">
              <button type="button" class="button mar-0-5 is-small" (click)="hideAssessmentModal(mesgIds)">
                Cancel
              </button>
              <button type="button" class="button is-link is-small" *ngIf="!showBtnSpinner"
                [disabled]="!assessmentSubmit" (click)="
                  submitAssessmentQuiz(
                    assessmentForm.value,
                    mesgIds,
                    'question'
                  )
                ">
                Submit Test
              </button>
              <a class="button is-link is-loading is-small" style="min-width: 100px" *ngIf="showBtnSpinner"></a>
            </div>
          </footer>
        </form>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Result</p>
          <button class="button is-primary is-light" style="margin-right: 14px" (click)="onClickTakeRetest(mesgIds)"
            *ngIf="isTakeRetest">
            Take Retest
          </button>
          <button class="delete" aria-label="close" (click)="hideModalAssessment(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Test Complete Date</th>
                  <th scope="col">Percentage %</th>
                  <!-- <th scope="col"></th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let st of getUserTestResult">
                  <td>{{ st.createdAt | date: "MM/dd/yyyy" }}</td>
                  <td>{{ st.percentage }}</td>
                  <!-- <td>
                    <button type="button" class="button mar-0-5 is-small is-link">Teacher Remarks</button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="isUserRole === 1">
        <div class="card-header">
          <p class="card-header-title">

            <a *ngIf="
                !viewControl.individualStudentResult &&
                viewControl.showIndStudentResult
              " (click)="hideStudentResults()" class="mar-0-5 has-tooltip-right" data-tooltip="Back to user">
              <i class="fa fa-arrow-left" aria-hidden="true" style="color: #fff !important;"></i>
            </a>
            <a *ngIf="!viewControl.showIndStudentResult" (click)="removeIndStudentResult()"
              class="mar-0-5 has-tooltip-right" data-tooltip="Back to user">
              <i class="fa fa-arrow-left" aria-hidden="true" style="color: #fff !important;"></i>
            </a>
            <span> Assessment Result</span>
          </p>
          <button class="delete" aria-label="close" (click)="hideModalAssessment(mesgIds)"></button>
        </div>
        <div class="card-content" *ngIf="
            viewControl.individualStudentResult &&
            viewControl.showIndStudentResult
          ">
          <!-- <div class="columns"> -->
          <div *ngIf="studentResult.length > 0; else elseTemplate">
            <!-- <div class="column is-12 is-fullwidth"> -->
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>User Name</th>
                  <th>Email Id</th>
                  <!-- <th>Percentage %</th> -->
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let m of studentResult">
                  <td>{{ m.createdAt | date: "MM/dd/yyyy" }}</td>
                  <td style="text-transform: capitalize" [innerHTML]="m.student_name"></td>
                  <td>{{ m.email_id }}</td>
                  <!-- <td>{{ m.percentage }}</td> -->
                  <td>
                    <button type="button" class="button mar-0-5 is-small is-link" (click)="indStudentResult(m)">
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- </div> -->
          </div>
          <!-- </div> -->
          <ng-template #elseTemplate>
            <span class="">There is no test submitted by the user</span>
          </ng-template>
        </div>
        <div class="card-content scroll-bar pos-relative" *ngIf="
            !viewControl.individualStudentResult &&
            viewControl.showIndStudentResult
          ">
          <div class="content">
            <div class="question">
              <h3 style="text-transform: capitalize">
                {{ individualStudentRecord[0]["student_name"] }}
              </h3>
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>Date & Time</th>
                    <th>Percentage %</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let m of individualStudentRecord">
                    <td>{{ m.createdAt | date: "MM/dd/yyyy hh:mm" }}</td>
                    <td>{{ m.percentage }}</td>

                    <td>
                      <button type="button" class="button mar-0-5 is-small is-link" [ngClass]="{
                          btnQAdisabled: m.answer_submissionId == null
                        }" (click)="onClickStudentIndResult(m)">
                        View QA
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card-content scroll-bar pos-relative" *ngIf="!viewControl.showIndStudentResult">
          <div class="content">
            <div class="question">
              <form [formGroup]="studentRemarkForm" novalidate>
                <div *ngFor="let data of viewStudentQA; let i = index" style="padding-bottom: 10px">
                  <div *ngIf="data.question_type == 'question'">
                    <h3 class="is-medium label is-size-6">
                      Q{{ i + 1 }}.
                      <span class="is-medium is-size-6" [innerHTML]="data.question"></span>
                    </h3>
                    <!-- <span *ngIf="data.answer_type==='text'" class="has-text-grey-lighter has-text-weight-bold" style="float: right;">Test Mark : {{data.test_mark}}</span> -->
                    <div *ngIf="data.answer_type === 'choice'; else elseTemplate">
                      <span *ngIf="
                          data.is_correct_answer === true;
                          else elseTemplate
                        ">
                        <span class="has-text-success">{{ data.answer }}</span>
                      </span>
                      <ng-template #elseTemplate>
                        <span class="has-text-danger">{{ data.answer }}</span>
                      </ng-template>
                    </div>
                    <ng-template #elseTemplate>
                      <h4 class="subtitle" style="
                          font-size: 14px;
                          margin-bottom: 5px;
                          color: #008000;
                        ">
                        Answer:
                      </h4>
                      <span>
                        {{ data.user_answer }}
                      </span>
                      <h5 class="is-size-6 has-text-danger-dark has-text-weight-bold" style="color: red;">Comments:</h5>
                      <div class="teacherRemarks" *ngIf="data.teacher_remark===''">
                        <input type="hidden" class="input" id="question_{{data.question_id}}" name="question_id"
                          style="margin-top: 10px" formControlName="question_id" value="{{ data.question_id }}" />
                        <textarea class="textarea" id="remark_{{data.question_id}}" name="remarks"
                          formControlName="remarks" (change)="
                            changeEvtTeacherRemark(data, studentRemarkForm.value)" cols="10" rows="2"
                          placeholder="Remarks"></textarea>
                        <input type="text" id="mark_{{data.question_id}}" style="margin-top: 10px" class="input"
                          formControlName="mark" (keypress)="numericOnlyHandler($event)"
                          (change)="changeRemarksMark(data, studentRemarkForm.value)" />
                      </div>
                      <div class="teacherRemarks" *ngIf="data.teacher_remark!=''">
                        <span class="has-text-info">{{data.teacher_remark}}</span><br />
                        <span class="has-text-success">Mark: {{data.teacher_mark}}</span>
                      </div>
                    </ng-template>
                  </div>
                </div>
                <footer class="card-footer">
                  <div class="column is-12 has-text-right">
                    <button type="button" class="button mar-0-5 is-small" (click)="removeIndStudentResult()">
                      Back
                    </button>
                    <button type="button" class="button is-link is-small" [disabled]="
                    (studentRemarkForm.valid && !studentRemarkForm.dirty) ||
                    studentRemarkForm.invalid
                  " (click)="submitRemarks(data, studentRemarkForm.value)" *ngIf="!showBtnSpinner"> Submit</button>
                    <a class="button is-link is-loading is-small" style="min-width: 100px;" *ngIf="showBtnSpinner"></a>
                  </div>
                </footer>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---Survey Records-->
  <div class="modal" [ngClass]="{ 'is-active': showHideSurveyModal[mesgIds] }">
    <div class="modal-background"></div>
    <div class="modal-card" style="padding:20px;">
      <div class="card" *ngIf="isUserRole != 1 && viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Survey Quiz</p>
          <button type="button" class="button is-outlined is-small" style="margin-top: 7px"
            (click)="hideSurveyQuizModal(mesgIds)">
            Cancel
          </button>
        </div>
        <div class="card-content scroll-bar pos-relative" infinite-scroll>
          <div class="content">
            <div class="question" *ngIf="mode == 'surveyQuiz'">
              <div *ngFor="let data of filteredQuestions; let i = index">
                <div class="badge badge-info">
                  Question {{ pager.index + 1 }} of {{ pager.count }}
                </div>
                <h3 class="is-medium label">
                  {{ pager.index + 1 }}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz">
                  <div class="" *ngFor="let option of data.answer; let i = index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <input class="is-checkradio" id="{{ option.answer_id }}-{{ data.question_id }}" type="radio"
                          name="{{ data.question_id }}-answers" [(ngModel)]="option.selected"
                          value="{{ option.answer_id }}" (change)="onSelectedSurRadio(data, option)" #surveyCheck />
                        <label [attr.for]="option.answer_id + '-' + data.question_id">{{ option.answer }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous"
              [ngClass]="{ hidePreviousBtn: pager.index === 0 }" [disabled]="pager.index == 0"
              [hidden]="pager.index > 1" (click)="getPreviewNext(pager.index - 1)">
              Previous
            </button>
            <div *ngIf="pager.index + 1 >= pager.count; else elseTemplate">
              <button type="button" class="button is-link is-small pagination-next answerSubmit"
                [disabled]="!surveySubmit" *ngIf="!showBtnSpinner" (click)="
                  submitAssessmentQuiz(filteredQuestions, mesgIds, 'survey')
                ">
                Submit Answer
              </button>
              <a class="button is-link is-loading is-small answerSubmit" style="min-width: 100px"
                *ngIf="showBtnSpinner"></a>
            </div>
            <ng-template #elseTemplate>
              <button type="button" class="button is-outlined pagination-next"
                (click)="getPreviewNext(pager.index + 1)">
                Next
              </button>
            </ng-template>
          </nav>
        </footer>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Survey Quiz</p>
          <button class="delete" aria-label="close" (click)="hideSurverModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <span class="is-small">Already survey is completed</span>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isUserRole === 1">
        <div class="card-header">
          <p class="card-header-title">Survey Result</p>
          <button class="delete" aria-label="close" (click)="hideSurverModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="mode == 'surveyQuiz'">
              <div *ngFor="let data of filterReportSurvey; let i = index">
                <div class="badge badge-info">
                  Question {{ pager.index + 1 }} of {{ pager.count }}
                </div>
                <h3 class="is-medium label">
                  {{ pager.index + 1 }}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz">
                  <div class="" *ngFor="let opt of data.answer; let i = index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <span class="is-small" [innerHTML]="opt.answer"></span>
                        <span class="has-text-right" style="float: right">{{ opt.count }} Votes</span>
                        <progress class="progress is-info" [ngClass]="{
                            'is-success': totalUserCount > opt.count
                          }" value="{{ opt.count }}" max="{{ totalUserCount }}">
                          {{ opt.count }}
                        </progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous" [disabled]="pager.index == 0"
              (click)="getPreviewNext(pager.index - 1)">
              Previous
            </button>
            <button type="button" class="button is-outlined pagination-next" [disabled]="pager.index + 1 >= pager.count"
              (click)="getPreviewNext(pager.index + 1)">
              Next
            </button>
          </nav>
        </footer>
      </div>
    </div>
  </div>

  <!--Poll Records -->
  <div class="modal" [ngClass]="{ 'is-active': showHidePollModal[mesgIds] }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card" *ngIf="isUserRole != 1 && viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Poll Quiz</p>
          <button class="delete" aria-label="close" (click)="hidePollActiveModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="getmode == 'pollsQuiz'">
              <div *ngFor="let data of pollfilterQuestions; let i = index">
                <div class="badge badge-info">
                  Question {{ pager.index + 1 }} of {{ pager.count }}
                </div>
                <h3 class="is-medium label">
                  {{ pager.index + 1 }}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz">
                  <div class="" *ngFor="let option of data.answer; let i = index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <input class="is-checkradio" id="{{ option.answer_id }}-{{ data.question_id }}" type="radio"
                          name="{{ data.question_id }}-answers" [(ngModel)]="option.selected"
                          value="{{ option.answer_id }}" (change)="onSelectedSurRadio(data, option)" #surveyCheck />
                        <label [attr.for]="option.answer_id + '-' + data.question_id">{{ option.answer }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous"
              [ngClass]="{ hidePreviousBtn: pager.index === 0 }" [disabled]="pager.index == 0"
              (click)="getPollNextPrev(pager.index - 1)">
              Previous
            </button>
            <div *ngIf="pager.index + 1 >= pager.count; else elseTemplate">
              <button type="button" class="button is-link is-small pagination-next answerSubmit"
                [disabled]="!pollBtnSubmit" *ngIf="!showBtnSpinner" (click)="
                  submitAssessmentQuiz(pollfilterQuestions, mesgIds, 'polls')
                ">
                Submit Answer
              </button>
              <a class="button is-link is-loading is-small answerSubmit" style="min-width: 100px"
                *ngIf="showBtnSpinner"></a>
            </div>
            <ng-template #elseTemplate>
              <button type="button" class="button is-outlined pagination-next"
                (click)="getPollNextPrev(pager.index + 1)">
                Next
              </button>
            </ng-template>
          </nav>
        </footer>
      </div>

      <div class="card" *ngIf="!viewControl.showAssessmentMarks">
        <div class="card-header">
          <p class="card-header-title">Poll Quiz</p>
          <button class="delete" aria-label="close" (click)="hidePollModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <span class="is-small">Already poll is completed</span>
          </div>
        </div>
      </div>

      <div class="card" *ngIf="isUserRole === 1">
        <div class="card-header">
          <p class="card-header-title">Poll Result</p>
          <button class="delete" aria-label="close" (click)="hidePollModal(mesgIds)"></button>
        </div>
        <div class="card-content">
          <div class="content">
            <div class="question" *ngIf="mode == 'surveyQuiz'">
              <div *ngFor="let data of pollsfilterReports; let i = index">
                <div class="badge badge-info">
                  Question {{ pager.index + 1 }} of {{ pager.count }}
                </div>
                <h3 class="is-medium label">
                  {{ pager.index + 1 }}.
                  <span class="is-medium" [innerHTML]="data.question"></span>
                </h3>
                <div class="options surveyquiz">
                  <div class="" *ngFor="let opt of data.answer; let i = index">
                    <div class="option has-text-grey-light">
                      <div class="field">
                        <span class="is-small" [innerHTML]="opt.answer"></span>
                        <span class="has-text-right" style="float: right">{{ opt.count }} Votes</span>
                        <progress class="progress is-info" [ngClass]="{
                            'is-success': totalUserCount > opt.count
                          }" value="{{ opt.count }}" max="{{ totalUserCount }}">
                          {{ opt.count }}
                        </progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <nav class="pagination is-small" role="navigation" aria-label="pagination">
            <button type="button" class="button is-outlined pagination-previous" [disabled]="pager.index === 0"
              (click)="getPollNextPrev(pager.index - 1)">
              Previous
            </button>
            <button type="button" class="button is-outlined pagination-next" [disabled]="pager.index + 1 >= pager.count"
              (click)="getPollNextPrev(pager.index + 1)">
              Next
            </button>
          </nav>
        </footer>
      </div>
    </div>
  </div>


  <div class="modal fade" [ngClass]="{'show':showSummarizationPopup}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Summarization</h5>
          <span class="pull-right" (click)="closeSummarization()"><i class="fa-solid fa-times"></i></span>
        </div>
        <div class="modal-body">
          <p [innerHTML]="changeNewLine(SummarizationText)"></p>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="modal fade documentpopup" [ngClass]="{'show':showDocumentPopup}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{msgTitle | titlecase}}</h5>
          <span class="pull-right" (click)="closeDocumentPopup()"><i class="fa-solid fa-times"></i></span>
        </div>
        <div class="modal-body">
         <ng-container [ngSwitch]="fileType">
          <div *ngSwitchCase="'application'">
              <ngx-doc-viewer
                   class="ngxDocViewer"
                   googleCheckContentLoaded="true"
                   googleCheckInterval="3000"
                   googleMaxChecks="5"
                      viewer="google"
                       [url]="selectedReadFile"
                      style="width: 100%; height: 80vh;">
                </ngx-doc-viewer>
          </div>
          <div *ngSwitchCase="'audio'">
             <audio [src]="selectedReadFile" controls></audio>
        </div>
        <div *ngSwitchCase="'video'">
          <video [src]="selectedReadFile" controls></video>
     </div>
         </ng-container>
 
        </div>
      </div>
    </div>
  </div>  -->
</div>

<pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader>